/* eslint-disable no-empty */
/* eslint-disable react-hooks/exhaustive-deps */
// libraries
import Slider from '@mui/material/Slider';
import Image from 'next/image';
import Link from 'next/link';
// import { useRouter } from 'next/router';
import dynamic from 'next/dynamic';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { FaBath, FaBed, FaCar, FaRulerCombined, FaTh, FaThList, FaTrashAlt } from 'react-icons/fa';
import { IoCloseSharp, IoFilterOutline } from 'react-icons/io5';
import { TailSpin } from 'react-loader-spinner';
import Select from 'react-select';
import { IconLinkedin } from '../../../../../assets';
// utils
import CloseIcon from '@mui/icons-material/Close';
import { IconButton } from '@mui/material';
import Box from '@mui/material/Box';
import Pagination from '@mui/material/Pagination';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import { motion, MotionConfig } from 'framer-motion';
import { isMobile } from 'react-device-detect';
import { HiMapPin } from 'react-icons/hi2';
const Mapa = dynamic(() => import('../../../../../components/pieces/mapa/mapa'), { ssr: false });
import { customSelectPropertiesStyles } from '../../../../../components/pieces/welcome/WelcomePieces.mocks';
import { useCidadesMulti } from '../../../../../components/shared/city-multi/useCidadesMulti';
import { useSelecaoMulti } from '../../../../../components/shared/multi-selecao/useSelecaoMulti';
import { getManagerId } from '../../../../../services/properties';
import { district, getEmpreendimentoById } from '../../../../../services/selectors';
import { isEmpreendimentoVisibleOnSite } from '../../../../../utils/empreendimentos';
import { pisoPrecoVenda, uniaoBairrosDasCidades } from '../../../../../utils/buscaMultiSelecao';
import { alternarQtd, CampoQtd, qtdMarcados } from '../../../../../utils/qtdMultiSelecao';
import { whatsParaImobiliaria } from '../../../../../utils/whatsappImobiliaria';
import { cidadesDoPais, estadosDoPais, paisDoEstado, temFiltroPais } from '../../../../../utils/filtroPais';
import { ordemSemMaisRecentes } from '../../../../../utils/ordemSemMaisRecentes';
const CardApartament = dynamic(() => import('../../../../../components/cards/apartament/CardApartament'), { ssr: false });
const CardApartament1 = dynamic(() => import('../../../../../components/cards/apartament/CardApartament1'), { ssr: false });
const CardApartament3 = dynamic(() => import('../../../../../components/cards/apartament/CardApartament3'), { ssr: false });
const CardApartamentHorizontal = dynamic(() => import('../../../../../components/cards/apartament/CardApartamentHorizontal'), { ssr: false });
// CARD "Foto imersiva" (modelo_card = 4): card 100% foto (aspect 4:5) com overlay
const CardApartamentImersivo = dynamic(() => import('../../../../../components/cards/apartament-imersivo/CardApartamentImersivo'), { ssr: false });
// CARD "Horizonte" (modelo #8, card 8): o MESMO card da home, em grade (só no gate ehModeloHorizonte).
const HorizonteCard = dynamic<IHorizonteCard>(() => import('../../../../../components/carousel/apartment/CardHorizonte').then((m) => m.HorizonteCard), { ssr: false });
import type { IHorizonteCard } from '../../../../../components/carousel/apartment/CardHorizonte';
import { EASE_HORIZONTE, ehModeloHorizonte, hexParaRgba, useMovimentoReduzido } from '../../../../../components/pieces/horizonte/horizonte';
// CARD "Atelier" (modelo_card = 9): na grade da listagem entra o MESMO card do carrossel da home.
const CardAtelierLista = dynamic<{ slide: any; site: any; codsite?: any; favorito: number[] }>(() => import('../../../../../components/carousel/apartment/CardAtelier').then((m) => m.CardAtelierLista), { ssr: false });
// CARDS "Aurora" (modelo #7, card 7) e "Panorama" (modelo #10, card 10): o MESMO card da home, em grade
// (só nos gates ehModeloAurora / ehModeloPanorama + o card do próprio modelo).
const AuroraCard = dynamic<IAuroraCard>(() => import('../../../../../components/carousel/apartment/CardAurora').then((m) => m.AuroraCard), { ssr: false });
import type { IAuroraCard } from '../../../../../components/carousel/apartment/CardAurora';
const PanoramaCard = dynamic<IPanoramaCard>(() => import('../../../../../components/carousel/apartment/CardPanorama').then((m) => m.PanoramaCard), { ssr: false });
import type { IPanoramaCard } from '../../../../../components/carousel/apartment/CardPanorama';
import { EASE_AURORA, ehModeloAurora } from '../../../../../components/pieces/aurora/aurora';
import { EASE_PANORAMA, ehModeloPanorama, paletaPanorama } from '../../../../../components/pieces/panorama/panorama';
// CARD "Larissa" (modelo #11, card 11): o MESMO card da home, em grade (só no gate ehModeloLarissa + card 11).
const LarissaCard = dynamic<ILarissaCard>(() => import('../../../../../components/carousel/apartment/CardLarissa').then((m) => m.LarissaCard), { ssr: false });
import type { ILarissaCard } from '../../../../../components/carousel/apartment/CardLarissa';
import { EASE_LARISSA, ehModeloLarissa, paletaLarissa, varsLarissaInterna } from '../../../../../components/pieces/larissa/larissa';
// CARD "Metrópole" (modelo #12, card 12): o MESMO card da home, em grade de 3/2/1 (só no gate ehModeloMetropole + card 12).
const MetropoleCard = dynamic<IMetropoleCard>(() => import('../../../../../components/carousel/apartment/CardMetropole').then((m) => m.MetropoleCard), { ssr: false });
import type { IMetropoleCard } from '../../../../../components/carousel/apartment/CardMetropole';
import { EASE_METROPOLE, ehModeloMetropole, paletaMetropole, varsMetropoleInterna } from '../../../../../components/pieces/metropole/metropole';
// CARD "Internacional" (modelo #12, card 13): o MESMO card da home, em grade (só no gate ehModeloInternacional + card 13).
const InternacionalCard = dynamic<IInternacionalCard>(() => import('../../../../../components/carousel/apartment/CardInternacional').then((m) => m.InternacionalCard), { ssr: false });
import type { IInternacionalCard } from '../../../../../components/carousel/apartment/CardInternacional';
import { EASE_INTERNACIONAL } from '../../../../../components/pieces/internacional/internacional';
import { coresInternas, estilosSelectInternacional } from '../../../../../components/pieces/internacional/internacionalInternas';
// CARD "Norte" (modelo #13, card 14): o MESMO card da home, em grade 3/2/1 (só no gate ehModeloNorte + card 14).
const NorteCard = dynamic<INorteCard>(() => import('../../../../../components/carousel/apartment/CardNorte').then((m) => m.NorteCard), { ssr: false });
import type { INorteCard } from '../../../../../components/carousel/apartment/CardNorte';
import { coresInternasNorte, estilosSelectNorte } from '../../../../../components/pieces/norte/norteInternas';
// CARD "Campo" (modelo #14, card 15): o MESMO card da home, em grade 3/2/1 (só no gate ehModeloCampo + card 15).
const CampoCard = dynamic<ICampoCard>(() => import('../../../../../components/carousel/apartment/CardCampo').then((m) => m.CampoCard), { ssr: false });
import type { ICampoCard } from '../../../../../components/carousel/apartment/CardCampo';
import { coresInternasCampo, estilosSelectCampo } from '../../../../../components/pieces/campo/campoInternas';

import { trackLead } from '../../../../../components/whatsAppButton/WhatsAppButton';
import {
    ensureReadableTextColor,
    formatSelects,
    getContrastRatio,
    hexToRgba,
    isColorLight,
    toPrice,
    useWindowSize
} from '../../../../../utils/FunctionsGlobals';
import PrecoMoeda from '../../../../../components/pieces/idiomas/PrecoMoeda';
import { temSeletorIdiomas } from '../../../../../utils/moedaSite';
import styles from './ListPiecesProperties.module.css';

// ---- Modelo #8 "Horizonte" (gate ehModeloHorizonte = topo 11) ----
// react-select no idioma do Horizonte: pílula 44px, borda sutil, foco no acento. Cores CALCULADAS
// (não CSS vars) porque o menu da ordenação vai em portal no <body>, fora da raiz da listagem.
const estilosSelectHorizonte = (texto: string, fundo: string, acento: string) => ({
    control: (base: any, state: any) => ({
        ...base,
        minHeight: 44,
        borderRadius: 999,
        background: 'transparent',
        boxShadow: 'none',
        border: `1px solid ${state.isFocused ? acento : hexParaRgba(texto, 0.28)}`,
        padding: '0 8px 0 12px',
        cursor: 'pointer',
        transition: 'border-color .2s ease',
        ':hover': { borderColor: state.isFocused ? acento : hexParaRgba(texto, 0.5) },
    }),
    valueContainer: (base: any) => ({ ...base, padding: '2px 4px' }),
    placeholder: (base: any) => ({ ...base, color: hexParaRgba(texto, 0.6), fontSize: 14, fontWeight: 500 }),
    singleValue: (base: any) => ({ ...base, color: texto, fontSize: 14, fontWeight: 600 }),
    input: (base: any) => ({ ...base, color: texto }),
    container: (base: any) => ({ ...base, color: texto }),
    indicatorSeparator: () => ({ display: 'none' }),
    dropdownIndicator: (base: any, state: any) => ({
        ...base,
        color: hexParaRgba(texto, 0.7),
        transition: 'transform .3s ease',
        transform: state.selectProps.menuIsOpen ? 'rotate(180deg)' : 'none',
        ':hover': { color: texto },
    }),
    clearIndicator: (base: any) => ({ ...base, color: hexParaRgba(texto, 0.6), ':hover': { color: texto } }),
    menu: (base: any) => ({
        ...base,
        backgroundColor: fundo,
        color: texto,
        border: `1px solid ${hexParaRgba(texto, 0.14)}`,
        borderRadius: 18,
        overflow: 'hidden',
        boxShadow: '0 18px 40px -22px rgba(0,0,0,.45)',
        zIndex: 10000,
    }),
    menuList: (base: any) => ({ ...base, padding: 6 }),
    option: (base: any, state: any) => ({
        ...base,
        borderRadius: 12,
        fontSize: 14,
        cursor: 'pointer',
        backgroundColor: state.isSelected ? texto : state.isFocused && !isMobile ? hexParaRgba(texto, 0.08) : 'transparent',
        color: state.isSelected ? fundo : texto,
        ':active': { backgroundColor: hexParaRgba(texto, 0.14) },
    }),
    noOptionsMessage: (base: any) => ({ ...base, color: hexParaRgba(texto, 0.6) }),
    loadingMessage: (base: any) => ({ ...base, color: hexParaRgba(texto, 0.6) }),
});

// Grade de HorizonteCard: entrada do modelo (opacity 0 / y 56 → 1 / 0, 0.9s, stagger 0.09 por
// coluna) dentro de MotionConfig "user". Componente próprio para o hook de movimento reduzido
// só existir no gate (os demais sites não ganham estado/efeito novo).
const GradeHorizonte: React.FC<{ imoveis: any[]; site: any; codsite: any; favorito: number[]; className: string; semEntrada?: boolean }> = ({
    imoveis,
    site,
    codsite,
    favorito,
    className,
    semEntrada,
}) => {
    const reduzido = useMovimentoReduzido();
    const parado = reduzido || Boolean(semEntrada);
    return (
        <MotionConfig reducedMotion="user">
            {imoveis.map((v: any, i: number) => (
                <motion.div
                    key={v?.id ?? i}
                    className={className}
                    initial={parado ? false : { opacity: 0, y: 56 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.12 }}
                    transition={parado ? { duration: 0 } : { duration: 0.9, delay: (i % 3) * 0.09, ease: EASE_HORIZONTE }}
                >
                    <HorizonteCard slide={v} site={site} codsite={codsite} favorito={favorito || []} reduzido={reduzido} />
                </motion.div>
            ))}
        </MotionConfig>
    );
};

// ---- Modelos #7 "Aurora" (gate ehModeloAurora = topo 10) e #10 "Panorama" (ehModeloPanorama = topo 13) ----
// A listagem no visual da home do modelo. Cores CALCULADAS aqui (o menu da ordenação vai em portal
// no <body>, fora da raiz) e as MESMAS viram CSS vars --lst-* na raiz (pages/imoveis/index.tsx);
// as regras de estilo ficam nos módulos CSS atrás de [data-modelo='aurora'|'panorama'].
// Fora dos dois modelos devolve null — nada muda nos demais sites.
export type CoresListagemAP = {
    modelo: 'aurora' | 'panorama';
    /** fundo da página (cor5) e texto/acento legíveis sobre ele */
    fundo: string;
    texto: string;
    acento: string;
    /** botão/pílula sólida do modelo (Aurora: cor2 · Panorama: acento quente) */
    solida: string;
    solidaTexto: string;
    /** painel de filtros = superfície BRANCA do modelo (card Aurora / cápsula da busca Panorama) */
    painelTexto: string;
    painelAcento: string;
    /** raio de campos/botões: Aurora pílula · Panorama 7px */
    raio: number;
};
export const coresListagemAP = (site: any): CoresListagemAP | null => {
    const aurora = ehModeloAurora(site);
    if (!aurora && !ehModeloPanorama(site)) return null;
    const fundo = site?.cor5 || '#f6f7f9';
    // mesmas contas do CardAurora/varsAurora: texto = cor11/cor13 com contraste sobre o fundo
    const texto = ensureReadableTextColor(isColorLight(fundo) ? site?.cor11 : site?.cor13, fundo) || '#1c2230';
    if (aurora) {
        const solida = site?.cor2 || '#1c2230';
        return {
            modelo: 'aurora',
            fundo,
            texto,
            acento: ensureReadableTextColor(site?.cor2, fundo, 3.0, texto, texto) || texto,
            solida,
            solidaTexto: ensureReadableTextColor(isColorLight(solida) ? site?.cor11 : site?.cor13, solida) || '#ffffff',
            painelTexto: '#1c2230',
            painelAcento: ensureReadableTextColor(site?.cor2, '#ffffff', 3.0, '#1c2230', '#1c2230') || '#1c2230',
            raio: 999,
        };
    }
    const p = paletaPanorama(site);
    // acento sobre o fundo da página: o quente quando lê ≥ 3:1; senão a versão escurecida; senão o texto
    const acento = getContrastRatio(p.acento, fundo) >= 3 ? p.acento : getContrastRatio(p.acentoEscuro, fundo) >= 3 ? p.acentoEscuro : texto;
    return {
        modelo: 'panorama',
        fundo,
        texto,
        acento,
        solida: p.acento,
        solidaTexto: p.acentoTexto,
        painelTexto: p.escuro,
        painelAcento: p.vivo,
        raio: 7,
    };
};
/** CSS vars --lst-* (+ color) da raiz da listagem nos modelos Aurora/Panorama. */
export const varsListagemAP = (c: CoresListagemAP | null): React.CSSProperties =>
    c
        ? ({
              color: c.texto,
              '--lst-fundo': c.fundo,
              '--lst-texto': c.texto,
              '--lst-acento': c.acento,
              '--lst-sutil': hexParaRgba(c.texto, 0.12),
              '--lst-sutil-forte': hexParaRgba(c.texto, 0.26),
              '--lst-solida': c.solida,
              '--lst-solida-texto': c.solidaTexto,
              '--lst-painel-texto': c.painelTexto,
              '--lst-painel-acento': c.painelAcento,
              '--lst-painel-sutil': hexParaRgba(c.painelTexto, 0.12),
              '--lst-painel-sutil-forte': hexParaRgba(c.painelTexto, 0.22),
          } as React.CSSProperties)
        : {};

// react-select no idioma do modelo: campo de 44px (pílula no Aurora, raio 7 no Panorama), borda sutil,
// foco no acento; o menu é sempre a superfície BRANCA do modelo (como o painel da busca da home).
const estilosSelectModeloAP = (texto: string, foco: string, c: CoresListagemAP) => {
    const pilula = c.raio > 100;
    return {
        control: (base: any, state: any) => ({
            ...base,
            minHeight: 44,
            borderRadius: c.raio,
            background: 'transparent',
            boxShadow: 'none',
            border: `1px solid ${state.isFocused ? foco : hexParaRgba(texto, 0.24)}`,
            padding: pilula ? '0 8px 0 12px' : '0 4px 0 8px',
            cursor: 'pointer',
            transition: 'border-color .2s ease',
            ':hover': { borderColor: state.isFocused ? foco : hexParaRgba(texto, 0.5) },
        }),
        valueContainer: (base: any) => ({ ...base, padding: '2px 4px' }),
        placeholder: (base: any) => ({ ...base, color: hexParaRgba(texto, 0.62), fontSize: 14, fontWeight: 500 }),
        singleValue: (base: any) => ({ ...base, color: texto, fontSize: 14, fontWeight: pilula ? 600 : 700 }),
        input: (base: any) => ({ ...base, color: texto }),
        container: (base: any) => ({ ...base, color: texto }),
        indicatorSeparator: () => ({ display: 'none' }),
        dropdownIndicator: (base: any, state: any) => ({
            ...base,
            color: hexParaRgba(texto, 0.7),
            transition: 'transform .3s ease',
            transform: state.selectProps.menuIsOpen ? 'rotate(180deg)' : 'none',
            ':hover': { color: texto },
        }),
        clearIndicator: (base: any) => ({ ...base, color: hexParaRgba(texto, 0.6), ':hover': { color: texto } }),
        menu: (base: any) => ({
            ...base,
            backgroundColor: '#ffffff',
            color: c.painelTexto,
            border: `1px solid ${hexParaRgba(c.painelTexto, 0.1)}`,
            borderRadius: pilula ? 18 : 10,
            overflow: 'hidden',
            boxShadow: '0 22px 50px rgba(0,0,0,.22)',
            zIndex: 10000,
        }),
        menuList: (base: any) => ({ ...base, padding: 6 }),
        option: (base: any, state: any) => ({
            ...base,
            borderRadius: pilula ? 12 : 6,
            fontSize: 14,
            fontWeight: state.isSelected ? 700 : 500,
            cursor: 'pointer',
            backgroundColor: state.isSelected
                ? hexParaRgba(c.painelAcento, 0.14)
                : state.isFocused && !isMobile
                ? hexParaRgba(c.painelTexto, 0.06)
                : 'transparent',
            color: c.painelTexto,
            ':active': { backgroundColor: hexParaRgba(c.painelAcento, 0.2) },
        }),
        noOptionsMessage: (base: any) => ({ ...base, color: hexParaRgba(c.painelTexto, 0.6) }),
        loadingMessage: (base: any) => ({ ...base, color: hexParaRgba(c.painelTexto, 0.6) }),
    };
};

// Grade de AuroraCard / PanoramaCard com a entrada do modelo (opacity 0 / y 40 → 1 / 0, 0.8s, cascata
// por coluna, EASE do modelo — a mesma das seções da home) dentro de MotionConfig "user". Componente
// próprio para o hook de movimento reduzido só existir no gate.
const GradeModeloAP: React.FC<{
    modelo: 'aurora' | 'panorama';
    imoveis: any[];
    site: any;
    codsite: any;
    favorito: number[];
    className: string;
    semEntrada?: boolean;
}> = ({ modelo, imoveis, site, codsite, favorito, className, semEntrada }) => {
    const reduzido = useMovimentoReduzido();
    const parado = reduzido || Boolean(semEntrada);
    // pílula de preço do AuroraCard: as MESMAS contas do CardAurora (cor2 sólida + texto calculado)
    const corPreco = site?.cor2 || '#1c2230';
    const corPrecoTexto = ensureReadableTextColor(isColorLight(corPreco) ? site?.cor11 : site?.cor13, corPreco) || '#ffffff';
    return (
        <MotionConfig reducedMotion="user">
            {imoveis.map((v: any, i: number) => (
                <motion.div
                    key={v?.id ?? i}
                    className={className}
                    initial={parado ? false : { opacity: 0, y: 40 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.12 }}
                    transition={parado ? { duration: 0 } : { duration: 0.8, delay: (i % 3) * 0.08, ease: modelo === 'aurora' ? EASE_AURORA : EASE_PANORAMA }}
                >
                    {modelo === 'aurora' ? (
                        <AuroraCard slide={v} site={site} codsite={codsite} favorito={favorito || []} corPreco={corPreco} corPrecoTexto={corPrecoTexto} />
                    ) : (
                        <PanoramaCard slide={v} site={site} codsite={codsite} favorito={favorito || []} reduzido={reduzido} />
                    )}
                </motion.div>
            ))}
        </MotionConfig>
    );
};

// ---- Modelo #11 "Larissa" (gate ehModeloLarissa = topo 14) ----
// A listagem na língua da home do modelo: monocromático, painel de filtros BRANCO (tinta/cinza/bordas
// da paleta), barra/chips/paginação sobre o fundo da página com o texto legível (--lr-texto, da raiz).
// As cores só são calculadas aqui para o que sai da raiz (menus do react-select em portal no <body>)
// e para o spinner; o resto é CSS atrás de [data-modelo='larissa'] (Properties.module.css +
// ListPiecesProperties.module.css). Fora do topo 14 devolve null — nada muda nos demais sites.
type CoresListagemLarissa = {
    /** texto legível sobre a cor5 (= --lr-texto da raiz) e os tons de página derivados dele */
    texto: string;
    textoSuave: string;
    sutil: string;
    sutilForte: string;
    /** paleta do modelo (superfícies BRANCAS: painel de filtros, menus) */
    base: string;
    hover: string;
    tinta: string;
    cinza: string;
    borda: string;
    bordaForte: string;
    fundo: string;
    sombra: string;
};
const coresListagemLarissa = (site: any): CoresListagemLarissa | null => {
    if (!ehModeloLarissa(site)) return null;
    const p = paletaLarissa(site);
    const vars = (varsLarissaInterna(site) || {}) as unknown as Record<string, string>;
    return {
        texto: vars['--lr-texto'] || p.tinta,
        textoSuave: vars['--lr-texto-suave'] || p.cinza,
        sutil: vars['--lr-sutil'] || hexParaRgba(p.tinta, 0.12),
        sutilForte: vars['--lr-sutil-forte'] || hexParaRgba(p.tinta, 0.24),
        base: p.base,
        hover: p.hover,
        tinta: p.tinta,
        cinza: p.cinza,
        borda: p.borda,
        bordaForte: p.bordaForte,
        fundo: p.fundo,
        sombra: vars['--lr-sombra'] || 'rgba(29, 29, 31, 0.12)',
    };
};

// react-select na língua do Larissa: campo de 44px, raio 8. No PAINEL (branco): fundo cinza-claro do
// modelo sem borda, foco = borda forte + fundo branco (os controles da busca da home). Na BARRA (sobre
// a cor5): transparente com contorno sutil no texto da página. Menu: sempre branco, raio 12, sombra longa.
const estilosSelectLarissa = (c: CoresListagemLarissa, painel: boolean) => {
    const texto = painel ? c.tinta : c.texto;
    const suave = painel ? c.cinza : c.textoSuave;
    return {
        control: (base: any, state: any) => ({
            ...base,
            minHeight: 44,
            borderRadius: 8,
            background: painel ? (state.isFocused ? '#ffffff' : c.fundo) : 'transparent',
            boxShadow: 'none',
            border: `1px solid ${painel ? (state.isFocused ? c.bordaForte : 'transparent') : state.isFocused ? texto : c.sutilForte}`,
            padding: '0 4px 0 6px',
            cursor: 'pointer',
            transition: 'border-color .2s ease, background-color .2s ease',
            ':hover': { borderColor: painel ? c.bordaForte : texto },
        }),
        valueContainer: (base: any) => ({ ...base, padding: '2px 6px' }),
        placeholder: (base: any) => ({ ...base, color: suave, fontSize: 14, fontWeight: 400 }),
        singleValue: (base: any) => ({ ...base, color: texto, fontSize: 14, fontWeight: 500 }),
        input: (base: any) => ({ ...base, color: texto }),
        container: (base: any) => ({ ...base, color: texto }),
        indicatorSeparator: () => ({ display: 'none' }),
        dropdownIndicator: (base: any, state: any) => ({
            ...base,
            color: suave,
            transition: 'transform .3s ease, color .2s ease',
            transform: state.selectProps.menuIsOpen ? 'rotate(180deg)' : 'none',
            ':hover': { color: texto },
        }),
        clearIndicator: (base: any) => ({ ...base, color: suave, ':hover': { color: texto } }),
        menu: (base: any) => ({
            ...base,
            backgroundColor: '#ffffff',
            color: c.tinta,
            border: `1px solid ${c.borda}`,
            borderRadius: 12,
            overflow: 'hidden',
            boxShadow: `0 1px 3px rgba(0, 0, 0, 0.05), 0 20px 40px -12px ${c.sombra}`,
            zIndex: 10000,
        }),
        menuList: (base: any) => ({ ...base, padding: 6 }),
        option: (base: any, state: any) => ({
            ...base,
            borderRadius: 8,
            fontSize: 14,
            fontWeight: state.isSelected ? 600 : 400,
            cursor: 'pointer',
            backgroundColor: state.isSelected ? c.fundo : state.isFocused && !isMobile ? c.fundo : 'transparent',
            color: c.tinta,
            ':active': { backgroundColor: c.borda },
        }),
        noOptionsMessage: (base: any) => ({ ...base, color: c.cinza }),
        loadingMessage: (base: any) => ({ ...base, color: c.cinza }),
    };
};

// Grade de LarissaCard com a entrada do modelo (opacity 0 / y 24 → 1 / 0, 0.7s, cascata por coluna,
// EASE_LARISSA — a mesma dos cards da home) dentro de MotionConfig "user". Componente próprio para o
// hook de movimento reduzido só existir no gate.
const GradeLarissa: React.FC<{
    imoveis: any[];
    site: any;
    codsite: any;
    favorito: number[];
    className: string;
    semEntrada?: boolean;
}> = ({ imoveis, site, codsite, favorito, className, semEntrada }) => {
    const reduzido = useMovimentoReduzido();
    const parado = reduzido || Boolean(semEntrada);
    return (
        <MotionConfig reducedMotion="user">
            {imoveis.map((v: any, i: number) => (
                <motion.div
                    key={v?.id ?? i}
                    className={className}
                    initial={parado ? false : { opacity: 0, y: 24 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.12 }}
                    transition={parado ? { duration: 0 } : { duration: 0.7, delay: (i % 3) * 0.08, ease: EASE_LARISSA }}
                >
                    <LarissaCard slide={v} site={site} codsite={codsite} favorito={favorito || []} />
                </motion.div>
            ))}
        </MotionConfig>
    );
};

// ---- Modelo #12 "Metrópole" (gate ehModeloMetropole = topo 15) ----
// A listagem na língua do modelo: página branca, UM acento (botão primário, aba ativa, número ativo, página
// atual), painel de filtros branco de borda fina (raio 8), campos de 44px com borda --mt-borda. As cores só
// são calculadas aqui para o que sai da raiz (menus do react-select em portal no <body>) e para o spinner;
// o resto é CSS atrás de [data-modelo='metropole'] (Properties.module.css + ListPiecesProperties.module.css).
// Fora do topo 15 devolve null — nada muda nos demais sites.
type CoresListagemMetropole = {
    /** texto legível sobre a cor5 (= --mt-texto-pagina da raiz) e os tons de página derivados dele */
    texto: string;
    textoSuave: string;
    sutil: string;
    sutilForte: string;
    /** paleta do modelo (superfícies BRANCAS: painel de filtros, menus) */
    acento: string;
    acentoHover: string;
    acentoSuave: string;
    tinta: string;
    cinza: string;
    borda: string;
    bordaSuave: string;
    fundo: string;
};
const coresListagemMetropole = (site: any): CoresListagemMetropole | null => {
    if (!ehModeloMetropole(site)) return null;
    const p = paletaMetropole(site);
    const vars = (varsMetropoleInterna(site) || {}) as unknown as Record<string, string>;
    return {
        texto: vars['--mt-texto-pagina'] || p.tinta,
        textoSuave: vars['--mt-texto-suave'] || p.cinza,
        sutil: vars['--mt-sutil'] || hexParaRgba(p.tinta, 0.12),
        sutilForte: vars['--mt-sutil-forte'] || hexParaRgba(p.tinta, 0.24),
        acento: p.acento,
        acentoHover: p.acentoHover,
        acentoSuave: p.acentoSuave,
        tinta: p.tinta,
        cinza: p.cinza,
        borda: p.borda,
        bordaSuave: p.bordaSuave,
        fundo: p.fundo,
    };
};

// react-select na língua do Metrópole: campo de 44px, raio 8, BRANCO com borda fina; foco = borda no acento.
// Na BARRA (sobre a cor5): transparente com contorno sutil no texto da página. Menu: branco, raio 8, sombra.
const estilosSelectMetropole = (c: CoresListagemMetropole, painel: boolean) => {
    const texto = painel ? c.tinta : c.texto;
    const suave = painel ? c.cinza : c.textoSuave;
    return {
        control: (base: any, state: any) => ({
            ...base,
            minHeight: 44,
            borderRadius: 8,
            background: painel ? '#ffffff' : 'transparent',
            boxShadow: 'none',
            border: `1px solid ${state.isFocused ? c.acento : painel ? c.borda : c.sutilForte}`,
            padding: '0 4px 0 6px',
            cursor: 'pointer',
            transition: 'border-color .2s ease, background-color .2s ease',
            ':hover': { borderColor: c.acento },
        }),
        valueContainer: (base: any) => ({ ...base, padding: '2px 6px' }),
        placeholder: (base: any) => ({ ...base, color: suave, fontSize: 14, fontWeight: 400 }),
        singleValue: (base: any) => ({ ...base, color: texto, fontSize: 14, fontWeight: 600 }),
        input: (base: any) => ({ ...base, color: texto }),
        container: (base: any) => ({ ...base, color: texto }),
        indicatorSeparator: () => ({ display: 'none' }),
        dropdownIndicator: (base: any, state: any) => ({
            ...base,
            color: suave,
            transition: 'transform .3s ease, color .2s ease',
            transform: state.selectProps.menuIsOpen ? 'rotate(180deg)' : 'none',
            ':hover': { color: c.acento },
        }),
        clearIndicator: (base: any) => ({ ...base, color: suave, ':hover': { color: c.acento } }),
        menu: (base: any) => ({
            ...base,
            backgroundColor: '#ffffff',
            color: c.tinta,
            border: `1px solid ${c.borda}`,
            borderRadius: 8,
            overflow: 'hidden',
            boxShadow: '0 8px 24px rgba(42, 42, 42, 0.16)',
            zIndex: 10000,
        }),
        menuList: (base: any) => ({ ...base, padding: 6 }),
        option: (base: any, state: any) => ({
            ...base,
            borderRadius: 6,
            fontSize: 14,
            fontWeight: state.isSelected ? 700 : 400,
            cursor: 'pointer',
            backgroundColor: state.isSelected ? c.acentoSuave : state.isFocused && !isMobile ? c.fundo : 'transparent',
            color: state.isSelected ? c.acento : c.tinta,
            ':active': { backgroundColor: c.acentoSuave },
        }),
        noOptionsMessage: (base: any) => ({ ...base, color: c.cinza }),
        loadingMessage: (base: any) => ({ ...base, color: c.cinza }),
    };
};

// Grade de MetropoleCard com a entrada do modelo (opacity 0 / y 24 → 1 / 0, 0.7s, cascata por coluna,
// EASE_METROPOLE — a mesma dos cards da home) dentro de MotionConfig "user".
const GradeMetropole: React.FC<{
    imoveis: any[];
    site: any;
    codsite: any;
    favorito: number[];
    className: string;
    semEntrada?: boolean;
}> = ({ imoveis, site, codsite, favorito, className, semEntrada }) => {
    const reduzido = useMovimentoReduzido();
    const parado = reduzido || Boolean(semEntrada);
    return (
        <MotionConfig reducedMotion="user">
            {imoveis.map((v: any, i: number) => (
                <motion.div
                    key={v?.id ?? i}
                    className={className}
                    initial={parado ? false : { opacity: 0, y: 24 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.12 }}
                    transition={parado ? { duration: 0 } : { duration: 0.7, delay: (i % 3) * 0.08, ease: EASE_METROPOLE }}
                >
                    <MetropoleCard slide={v} site={site} codsite={codsite} favorito={favorito || []} />
                </motion.div>
            ))}
        </MotionConfig>
    );
};

// ---- Modelo #12 "Internacional" (gate ehModeloInternacional = topo 16) ----
// Grade do InternacionalCard (o card da home) com a entrada do modelo (opacity 0 / y 24 → 1 / 0, 0.7s, cascata por
// coluna, EASE_INTERNACIONAL). As cores da listagem vêm de coresInternas (internacionalInternas.ts); o resto é CSS
// atrás de [data-modelo='internacional'] (Properties.module.css + ListPiecesProperties.module.css). Fora do topo 16:
// coresIn = null ⇒ nada muda nos demais sites.
const GradeInternacional: React.FC<{
    imoveis: any[];
    site: any;
    codsite: any;
    favorito: number[];
    className: string;
    semEntrada?: boolean;
}> = ({ imoveis, site, codsite, favorito, className, semEntrada }) => {
    const reduzido = useMovimentoReduzido();
    const parado = reduzido || Boolean(semEntrada);
    return (
        <MotionConfig reducedMotion="user">
            {imoveis.map((v: any, i: number) => (
                <motion.div
                    key={v?.id ?? i}
                    className={className}
                    initial={parado ? false : { opacity: 0, y: 24 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.12 }}
                    transition={parado ? { duration: 0 } : { duration: 0.7, delay: (i % 3) * 0.08, ease: EASE_INTERNACIONAL }}
                >
                    <InternacionalCard slide={v} site={site} codsite={codsite} favorito={favorito || []} />
                </motion.div>
            ))}
        </MotionConfig>
    );
};

// ---- Modelo #13 "Norte" (gate ehModeloNorte = topo 17) ----
// Grade do NorteCard (o card da home, branco raio 8) com uma entrada leve (opacity 0 / y 16 → 1 / 0, 0.5s, cascata
// por coluna). Cores: coresInternasNorte (norteInternas.ts); o resto é CSS atrás de [data-modelo='norte']
// (Properties.module.css + ListPiecesProperties.module.css). Fora do topo 17: coresNt = null ⇒ nada muda.
const GradeNorte: React.FC<{
    imoveis: any[];
    site: any;
    codsite: any;
    favorito: number[];
    className: string;
    semEntrada?: boolean;
}> = ({ imoveis, site, codsite, favorito, className, semEntrada }) => {
    const reduzido = useMovimentoReduzido();
    const parado = reduzido || Boolean(semEntrada);
    return (
        <MotionConfig reducedMotion="user">
            {imoveis.map((v: any, i: number) => (
                <motion.div
                    key={v?.id ?? i}
                    className={className}
                    initial={parado ? false : { opacity: 0, y: 16 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.12 }}
                    transition={parado ? { duration: 0 } : { duration: 0.5, delay: (i % 3) * 0.06, ease: EASE_INTERNACIONAL }}
                >
                    <NorteCard slide={v} site={site} codsite={codsite} favorito={favorito || []} />
                </motion.div>
            ))}
        </MotionConfig>
    );
};

// ---- Modelo #14 "Campo" (gate ehModeloCampo = topo 18) ----
// Grade do CampoCard (o card da home: cartão raio 20 sobre o papel) com a mesma entrada leve do Norte (opacity 0 / y 16
// → 1 / 0, 0.5s, cascata por coluna). Cores: coresInternasCampo (campoInternas.ts); o resto é CSS atrás de
// [data-modelo='campo'] (Properties.module.css + ListPiecesProperties.module.css). Fora do topo 18: coresCp = null.
const GradeCampo: React.FC<{
    imoveis: any[];
    site: any;
    codsite: any;
    favorito: number[];
    className: string;
    semEntrada?: boolean;
}> = ({ imoveis, site, codsite, favorito, className, semEntrada }) => {
    const reduzido = useMovimentoReduzido();
    const parado = reduzido || Boolean(semEntrada);
    return (
        <MotionConfig reducedMotion="user">
            {imoveis.map((v: any, i: number) => (
                <motion.div
                    key={v?.id ?? i}
                    className={className}
                    initial={parado ? false : { opacity: 0, y: 16 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.12 }}
                    transition={parado ? { duration: 0 } : { duration: 0.5, delay: (i % 3) * 0.06, ease: EASE_INTERNACIONAL }}
                >
                    <CampoCard slide={v} site={site} codsite={codsite} favorito={favorito || []} />
                </motion.div>
            ))}
        </MotionConfig>
    );
};

const DEBOUNCE_MS = 2000;   // 1 segundo

// FILTRO "ÁREA PRIVATIVA" ESCONDIDO (pedido do cs1913 em 26/08/2026): tenants cuja carteira
// é de terrenos/áreas de terra, onde os dois campos de m² privativos não fazem sentido e só
// confundem quem busca. Allowlist por codsite — em todos os outros sites o filtro continua.
const SEM_FILTRO_AREA_PRIVATIVA_SITES = [1913];
const fallbackEmpreendimentoImage = 'https://fotos.sobressai.com.br/Fotos/imovel_sem_foto.jpg';

const stripHtmlText = (value: string | null | undefined) =>
    String(value || '')
        .replace(/<[^>]*>/g, ' ')
        .replace(/&nbsp;/gi, ' ')
        .replace(/\s+/g, ' ')
        .trim();

const uniqueFeatureList = (items: string[]) => {
    const seen = new Set<string>();
    const normalized: string[] = [];

    items.forEach((item) => {
        const clean = stripHtmlText(item);
        if (!clean) return;
        const key = clean.toLowerCase();
        if (seen.has(key)) return;
        seen.add(key);
        normalized.push(clean);
    });

    return normalized;
};

const extractEmpreendimentoCaracteristicas = (empreendimento: any) => {
    const fromApi = Array.isArray(empreendimento?.caracteristicas_detalhes)
        ? empreendimento.caracteristicas_detalhes
            .map((item: any) => stripHtmlText(item?.nome))
            .filter(Boolean)
        : [];

    if (fromApi.length > 0) {
        return uniqueFeatureList(fromApi).slice(0, 8);
    }

    const fallbackTokens = stripHtmlText(
        empreendimento?.descricao || empreendimento?.Descricao_interna || empreendimento?.meta_description
    )
        .split(/[.;,|]/)
        .map((item) => item.trim())
        .filter((item) => item.length >= 3 && item.length <= 42 && item.split(/\s+/).length <= 6);

    return uniqueFeatureList(fallbackTokens).slice(0, 8);
};

const parseAreaValue = (value: any) => {
    if (value === null || value === undefined) return 0;
    const normalized = Number(String(value).replace(',', '.').replace(/[^\d.]/g, ''));
    return Number.isFinite(normalized) && normalized > 0 ? normalized : 0;
};

const parsePositiveNumber = (value: any) => {
    const parsed = Number(value);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : 0;
};

const formatCurrency = (value: number) =>
    new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
        maximumFractionDigits: 0
    }).format(value);

const formatAreaNumber = (value: number) =>
    new Intl.NumberFormat('pt-BR', {
        minimumFractionDigits: value % 1 === 0 ? 0 : 1,
        maximumFractionDigits: value % 1 === 0 ? 0 : 1
    }).format(value);

const formatPriceRange = (minValue: any, maxValue: any) => {
    const min = parsePositiveNumber(minValue);
    const max = parsePositiveNumber(maxValue);

    if (min > 0 && max > 0) {
        if (min === max) return formatCurrency(min);
        return `${formatCurrency(min)} à ${formatCurrency(max)}`;
    }
    if (min > 0) return `a partir de ${formatCurrency(min)}`;
    if (max > 0) return `até ${formatCurrency(max)}`;
    return '';
};

const formatAreaRange = (areaMin: any, areaMinAlt: any, areaMax: any) => {
    const min = parseAreaValue(areaMin) || parseAreaValue(areaMinAlt);
    const max = parseAreaValue(areaMax);

    if (min > 0 && max > 0) {
        if (min === max) return `${formatAreaNumber(min)} m²`;
        return `${formatAreaNumber(min)} à ${formatAreaNumber(max)} m²`;
    }
    if (min > 0) return `a partir de ${formatAreaNumber(min)} m²`;
    if (max > 0) return `até ${formatAreaNumber(max)} m²`;
    return '';
};

const formatQtdRange = (minValue: any, maxValue: any, singular: string, plural: string, fallback?: any) => {
    const min = parsePositiveNumber(minValue);
    const max = parsePositiveNumber(maxValue);
    const fallbackValue = parsePositiveNumber(fallback);

    if (min > 0 && max > 0) {
        if (min === max) return `${formatAreaNumber(min)} ${min === 1 ? singular : plural}`;
        return `${formatAreaNumber(min)} à ${formatAreaNumber(max)} ${plural}`;
    }
    if (max > 0) return `até ${formatAreaNumber(max)} ${plural}`;
    if (min > 0) return `a partir de ${formatAreaNumber(min)} ${plural}`;
    if (fallbackValue > 0) return `${formatAreaNumber(fallbackValue)} ${fallbackValue === 1 ? singular : plural}`;
    return '';
};

const formatSituacao = (value: string | null | undefined) => {
    const key = String(value || '').toLowerCase();
    const map: Record<string, string> = {
        emconstrucao: 'Em construção',
        lancamento: 'Lançamento',
        pronto: 'Pronto para morar'
    };
    return map[key] || String(value || 'Disponível');
};

const getFotoUrlFromFotos = (fotos: any) => {
    if (!fotos) return '';

    if (typeof fotos === 'string') {
        return fotos;
    }

    const list = Array.isArray(fotos)
        ? fotos
        : typeof fotos === 'object'
            ? Object.values(fotos)
            : [];

    const first = list.find((item: any) => {
        if (!item) return false;
        if (typeof item === 'string') return Boolean(item);
        return Boolean(item?.url_foto || item?.url_spaces_cdn || item?.url_spaces_migracao || item?.url_marca);
    });

    if (!first) return '';
    if (typeof first === 'string') return first;
    return first?.url_foto || first?.url_spaces_cdn || first?.url_spaces_migracao || first?.url_marca || '';
};

const ListPiecesProperties: React.FC<{
    allProperties: Array<any>;
    setAllProperties?: any;
    allPropertiesMapa: Array<any>;
    site: any;
    page: any;
    setPage: any;
    searchList: any;
    qtd: number;
    typeValidation: any;
    first: any;
    typeActual?: any;
    setTypeActual?: any;
    districtActual?: any;
    setDistrictActual?: any;
    cityActual?: any;
    /** MULTI-FILIAIS: ids vindos de `?cidades=` para semear o select multi. */
    cidadesSeed?: number[];
    /** MULTI-FILIAIS: devolve à página as cidades marcadas no select multi. */
    onCidadesMulti?: (_ids: number[]) => void;
    /** cs834 (utils/buscaMultiSelecao): condomínios/categorias com seleção múltipla + piso da régua. */
    buscaMulti?: boolean;
    /** Atelier (utils/qtdMultiSelecao): os botões 1·2·3·4·5+ marcam vários números. */
    qtdMulti?: boolean;
    /** modelos novos + cs834 (utils/buscaMultiSelecao): várias cidades e os bairros de todas elas. */
    localMulti?: boolean;
    condominiosSeed?: number[];
    categoriasSeed?: number[];
    onCondominiosMulti?: (_ids: number[]) => void;
    onCategoriasMulti?: (_ids: number[]) => void;
    /** muda a cada "Ver todos os imóveis" da página → desmarca as listas. */
    zeraMultiToken?: number;
    filtersInitialized?: any;
    setCityActual?: any;
    codeActual?: any;
    setCodeActual?: any;
    companyActual?: any;
    setCompanyActual?: any;
    orderActual?: any;
    setOrderActual?: any;
    price?: any;
    setPrice?: any;
    filterPrice?: any;
    setFilterPrice?: any;
    listCity?: any;
    allCities: Array<{label: string, value: number,id_estado: any}>;
    setListCity?: any;
    listType?: any;
    listCompany?: any;
    listDistrict?: any;
    setListDistrict?: any;
    type?: any;
    setType?: any;
    filters?: any;
    setAutorizaBusca?: any;
    setFilters?: any;
    applyFilter?: any;
    activeLargeFilter?: any;
    setActiveLargeFilter?: any;
    companyInputActual?: any;
    setCompanyInputActual?: any;
    loading?: any;
    setLoading?: any;
    renderTextFilters?: any;
    agenciador?: Number;
    setAgenciador?: any;
    favorito: any;
    setFavorito: any;
    openFavoritos: boolean;
    setOpenFavoritos?: any;
    naoEncontrou?: boolean;
    zeraFiltros?: () => void;
    emptyStateSuggestions?: any[];
    allUrl?: any;
    origin?: any;
    codsite?: any;
    codsite2?: any;
    valores?: any;
    listCategory?: any;
    listCaract?: any;
    caractActual?: any;
    setCaractActual?: any;
    categoryActual?: any;
    setCategoryActual?: any;
    listEstados?: any;
    setEstadoActual?: any;
    estadoActual: any;
    /** cs2065: filtro de País separado do Estado (utils/filtroPais). */
    listPaises?: any;
    paisActual?: any;
    setPaisActual?: any;
    listDatas?: any;
    dataEntregaActual?: any;
    setDataEntregaActual?: any;
    area: any;
    setArea: any;
    allViewProperties: any;
    disableEntryMotion?: boolean;
    // BUSCA POR IA (INC-0018 F4) — só chegam preenchidos quando a URL veio da busca por IA;
    // ausentes, a listagem renderiza exatamente como antes.
    /** faixa do aviso da IA (acima dos resultados) */
    faixaBuscaIa?: React.ReactNode;
    /** opção "Mais próximos de {lugar}" do Ordenar (só com `perto` na URL) */
    opcaoOrdemBuscaIa?: { label: string; value: string } | null;
    /** mínimos da IA ativos ("2+ suítes"), como chips removíveis */
    minimosBuscaIa?: Array<{ campo: string; rotulo: string }>;
    onRemoverMinimoBuscaIa?: (_campo: string) => void;
}> = ({
    listDatas,
    dataEntregaActual,
    setDataEntregaActual,
    allProperties,
    allPropertiesMapa,
    setAllProperties,
    site,
    first,
    page,
    setPage,
    setAutorizaBusca,
    searchList: _searchList,
    qtd,
    filtersInitialized: _filtersInitialized,
    setArea,
    area,
    typeValidation,
    typeActual,
    setTypeActual,
    districtActual,
    setDistrictActual,
    cityActual,
    setCityActual,
    cidadesSeed,
    onCidadesMulti,
    buscaMulti,
    qtdMulti,
    localMulti,
    condominiosSeed,
    categoriasSeed,
    onCondominiosMulti,
    onCategoriasMulti,
    zeraMultiToken,
    codeActual,
    setCodeActual,
    companyActual,
    setCompanyActual,
    orderActual,
    setOrderActual,
    price,
    setPrice,
    filterPrice,
    setFilterPrice,
    listCity,
    setListCity,
    allCities,
    listType,
    listCompany,
    listDistrict,
    setListDistrict,
    type,
    setType,
    filters,
    setFilters,
    applyFilter,
    activeLargeFilter,
    setActiveLargeFilter,
    companyInputActual,
    setCompanyInputActual,
    loading,
    setLoading,
    renderTextFilters,
    agenciador,
    setAgenciador,
    favorito,
    setFavorito,
    openFavoritos,
    setOpenFavoritos,
    naoEncontrou,
    zeraFiltros,
    emptyStateSuggestions,
    allUrl: _allUrl,
    origin,
    codsite,
    valores,
    codsite2,
    listCategory,
    listCaract,
    caractActual,
    setCaractActual,
    categoryActual,
    setCategoryActual,
    listEstados,
    setEstadoActual,
    estadoActual,
    listPaises,
    paisActual,
    setPaisActual,
    allViewProperties,
    disableEntryMotion,
    faixaBuscaIa,
    opcaoOrdemBuscaIa,
    minimosBuscaIa,
    onRemoverMinimoBuscaIa
}) => {
    // constants
    // `|| cor padrão` porque a coluna do tenant pode vir NULL (13 sites hoje sem cor13) — mesma
    // convenção do _app.tsx e do card de /condominios. Sem isso a cor nula descia até o
    // hexToRgba e derrubava a listagem inteira com 500 (cs2602).
    // Modelo #8 "Horizonte" (topo 11): as cores da home (CardHorizonte varsSecao, fundo = cor5) e
    // nenhum inline legado de borda/fundo — o estilo vem do CSS atrás de [data-modelo='horizonte']
    // (posto na raiz em pages/imoveis/index.tsx). Fora do gate tudo segue exatamente como antes.
    const horizonte = ehModeloHorizonte(site);
    const cardHorizonte = horizonte && Number(site?.modelo_card) === 8;
    const corFundoHz = site?.cor5 || '#f5f4f1';
    const corTextoHz = horizonte ? ensureReadableTextColor(isColorLight(corFundoHz) ? site?.cor11 : site?.cor13, corFundoHz) || '#141821' : '';
    const corAcentoHz = horizonte ? ensureReadableTextColor(site?.cor2, corFundoHz, 3.0, corTextoHz, corTextoHz) || corTextoHz : '';
    // Modelos #7 "Aurora" (topo 10) e #10 "Panorama" (topo 13): mesmo esquema — sem inline legado
    // (legado()), estilo nos módulos CSS atrás de [data-modelo='aurora'|'panorama']; o painel de
    // filtros é a superfície BRANCA do modelo (corLetra1 = texto do painel) e a barra/cabeçalho usam
    // o texto legível sobre o fundo da página (corLetra2). Grade = o card da home (card 7 / card 10).
    const coresAP = coresListagemAP(site);
    const cardModeloAP = coresAP ? Number(site?.modelo_card) === (coresAP.modelo === 'aurora' ? 7 : 10) : false;
    // Modelo #11 "Larissa" (topo 14): mesmo esquema — sem inline legado, estilo nos módulos CSS atrás de
    // [data-modelo='larissa']; o painel de filtros é BRANCO (corLetra1 = tinta do modelo) e a barra/cabeçalho
    // usam o texto legível sobre a cor5 (corLetra2 = --lr-texto). Grade = o LarissaCard da home (card 11).
    const coresLr = coresListagemLarissa(site);
    const cardLarissa = Boolean(coresLr) && Number(site?.modelo_card) === 11;
    // Modelo #12 "Metrópole" (topo 15): mesmo esquema — CSS atrás de [data-modelo='metropole']; painel de filtros BRANCO
    // (corLetra1 = tinta do modelo), barra/cabeçalho no texto legível sobre a cor5 (corLetra2). Grade = MetropoleCard (card 12).
    const coresMt = coresListagemMetropole(site);
    const cardMetropole = Boolean(coresMt) && Number(site?.modelo_card) === 12;
    // Modelo #12 "Internacional" (topo 16): idem — página CLARA do modelo (painel branco, tinta/texto da paleta), grade = InternacionalCard (card 13).
    const coresIn = coresInternas(site);
    const cardIn = Boolean(coresIn) && Number(site?.modelo_card) === 13;
    // Modelo #13 "Norte" (topo 17): idem — página BRANCA, campos RETOS, grade = NorteCard (card 14).
    const coresNt = coresInternasNorte(site);
    const cardNt = Boolean(coresNt) && Number(site?.modelo_card) === 14;
    // Modelo #14 "Campo" (topo 18): idem — página de PAPEL, campos e botões em PÍLULA, grade = CampoCard (card 15).
    const coresCp = coresInternasCampo(site);
    const cardCp = Boolean(coresCp) && Number(site?.modelo_card) === 15;
    const legado = <T,>(estilo: T): T | undefined => (horizonte || coresAP || coresLr || coresMt || coresIn || coresNt || coresCp ? undefined : estilo);
    const corLetra1 = horizonte ? corTextoHz : coresAP ? coresAP.painelTexto : coresLr ? coresLr.tinta : coresMt ? coresMt.tinta : coresIn ? coresIn.tinta : coresNt ? coresNt.tinta : coresCp ? coresCp.tinta : isColorLight(site?.cor2) ? (site?.cor11 || '#111827') : (site?.cor2 || '#111827');
    const corLetra2 = horizonte ? corTextoHz : coresAP ? coresAP.texto : coresLr ? coresLr.texto : coresMt ? coresMt.texto : coresIn ? coresIn.texto : coresNt ? coresNt.texto : coresCp ? coresCp.tinta : isColorLight(site?.cor5) ? (site?.cor11 || '#111827') : (site?.cor13 || '#ffffff');

    const corFundo = "#FFFFFF";
    const estilosSelectHz = horizonte ? estilosSelectHorizonte(corTextoHz, corFundoHz, corAcentoHz) : null;
    const estilosSelectPainelAP = coresAP ? estilosSelectModeloAP(coresAP.painelTexto, coresAP.painelAcento, coresAP) : null;
    const estilosSelectBarraAP = coresAP ? estilosSelectModeloAP(coresAP.texto, coresAP.acento, coresAP) : null;
    const estilosSelectPainelLr = coresLr ? estilosSelectLarissa(coresLr, true) : null;
    const estilosSelectBarraLr = coresLr ? estilosSelectLarissa(coresLr, false) : null;
    const estilosSelectPainelMt = coresMt ? estilosSelectMetropole(coresMt, true) : null;
    const estilosSelectBarraMt = coresMt ? estilosSelectMetropole(coresMt, false) : null;
    const estilosSelectPainelIn = coresIn ? estilosSelectInternacional(coresIn, true) : null;
    const estilosSelectBarraIn = coresIn ? estilosSelectInternacional(coresIn, false) : null;
    const estilosSelectPainelNt = coresNt ? estilosSelectNorte(coresNt, true) : null;
    const estilosSelectBarraNt = coresNt ? estilosSelectNorte(coresNt, false) : null;
    const estilosSelectPainelCp = coresCp ? estilosSelectCampo(coresCp, true) : null;
    const estilosSelectBarraCp = coresCp ? estilosSelectCampo(coresCp, false) : null;
    const colorPicker = estilosSelectHz || estilosSelectPainelAP || estilosSelectPainelLr || estilosSelectPainelMt || estilosSelectPainelIn || estilosSelectPainelNt || estilosSelectPainelCp || customSelectPropertiesStyles(corLetra1,corFundo,site?.cor2,corLetra1);
    const colorPicker1 = estilosSelectHz || estilosSelectBarraAP || estilosSelectBarraLr || estilosSelectBarraMt || estilosSelectBarraIn || estilosSelectBarraNt || estilosSelectBarraCp || customSelectPropertiesStyles(corLetra2,site?.cor5,site?.cor2,corLetra2,true);
    const colorPickerCompany = estilosSelectHz || estilosSelectPainelAP || estilosSelectPainelLr || estilosSelectPainelMt || estilosSelectPainelIn || estilosSelectPainelNt || estilosSelectPainelCp || customSelectPropertiesStyles(corLetra1,corFundo,site?.cor2,corLetra1);
    const orderSelectStyles = useMemo(
        () => ({
            ...colorPicker1,
            // Horizonte: a ordenação acompanha as pílulas de 40px da barra (Mapa, grade/lista).
            ...(estilosSelectHz ? { control: (base: any, state: any) => ({ ...estilosSelectHz.control(base, state), minHeight: 40 }) } : {}),
            menu: (base: any) => {
                const themedMenu = colorPicker1?.menu ? colorPicker1.menu(base) : base;
                return {
                    ...themedMenu,
                    zIndex: 20000,
                    pointerEvents: 'auto'
                };
            },
            menuPortal: (base: any) => ({
                ...base,
                zIndex: 20000,
                pointerEvents: 'auto'
            })
        }),
        [colorPicker1, estilosSelectHz]
    );
    const orderSelectPortalTarget =
        typeof window !== 'undefined' ? document.body : undefined;
    const [codeInput, setCodeInput] = useState(codeActual || "");
    const handleChange = (event: React.ChangeEvent<unknown>, value: number) => {
        setPage(value);
        setLoading(true);
        setAutorizaBusca(true);
        window.scroll({top:300, behavior: "smooth"})
    };
    const marginIconTag = legado({ marginTop: 3 });
    const minDistance = 1000;
    const size = useWindowSize();
    const stylesIconClose = horizonte || coresAP || coresLr || coresMt || coresIn || coresNt || coresCp ? 'currentColor' : corLetra1;
    const stylesIconClose1 = horizonte || coresAP || coresLr || coresMt || coresIn || coresNt || coresCp ? 'currentColor' : corLetra2;
    const stylesTags = legado({
        color: corLetra2,
        border: `2px solid ${corLetra2}`,
    });
    const stylesTags2 = legado({
        color: corLetra1,
        border: `2px solid ${corLetra1}`,
    });
    const motionBase = disableEntryMotion
        ? { initial: false, animate: { opacity: 1, y: 0 }, transition: { duration: 0 } }
        : { initial: { opacity: 0, y: 50 }, animate: { opacity: 1, y: 0 } };
    const initializeSquareCardsLayout = String(site?.id) === '2474';
    const isSite2507 = String(site?.id) === '2507';
    // cs2587 (TEOMI, sugestão #56): "tem empreendimento que não é condomínio e sim loteamento".
    // GATE por codsite — os demais ~300 sites seguem com "Condomínios".
    const isSite2587 = String(site?.id) === '2587';
    const formatSelectedCount = (
        items: Array<any>,
        singular: string,
        plural: string
    ) => {
        const count = items?.length || 0;
        if (count === 0) return '';
        return `${count} ${count === 1 ? singular : plural} selecionado${count === 1 ? '' : 's'}`;
    };
    // const router = useRouter();
    // const { pagination } = router.query;
    // useState
    const [imput_price, setImput_price] = useState<any>(price);
    const [managerActual, setManagerActual] = useState<any>(null);
    const [lastType, setLastType] = useState<any>(type);
    const [mapaOn, setMapaOn] = useState<any>(0);
    // card 9 (Atelier) abre na GRADE: o card é retrato, como na home (a lista horizontal segue no botão)
    const [positionCard, setPositionCard] = useState<any>(
        site?.modelo_card > 1 && site?.modelo_card != 9 && !isMobile && !initializeSquareCardsLayout && !cardHorizonte && !cardModeloAP && !cardLarissa && !cardMetropole && !cardIn && !cardNt && !cardCp ? 1 : 0
    );
    const isHorizontalCardLayout = Boolean(positionCard);
    const [status, setStatus] = useState('');
    const [areaAux,setAreaAux] = useState(area)
    const [empreendimentoDetalhe, setEmpreendimentoDetalhe] = useState<any>(null);
    const [empreendimentoDetalheLoading, setEmpreendimentoDetalheLoading] = useState(false);
    const [orderMenuOpen, setOrderMenuOpen] = useState(false);
    const [orderMenuInteractionLocked, setOrderMenuInteractionLocked] = useState(false);
    const orderSelectRef = useRef<any>(null);
    const orderMenuUnlockTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

    const clearOrderMenuUnlockTimeout = () => {
        if (orderMenuUnlockTimeoutRef.current) {
            clearTimeout(orderMenuUnlockTimeoutRef.current);
            orderMenuUnlockTimeoutRef.current = null;
        }
    };

    const closeOrderMenu = () => {
        clearOrderMenuUnlockTimeout();
        setOrderMenuOpen(false);
        setOrderMenuInteractionLocked(false);
        orderSelectRef.current?.blur?.();
    };

    const handleOrderMenuOpen = () => {
        if (activeLargeFilter) {
            closeOrderMenu();
            return;
        }

        clearOrderMenuUnlockTimeout();
        setOrderMenuOpen(true);
        setOrderMenuInteractionLocked(true);
    };

    const handleOrderMenuClose = () => {
        setOrderMenuOpen(false);
        clearOrderMenuUnlockTimeout();
        orderMenuUnlockTimeoutRef.current = setTimeout(() => {
            setOrderMenuInteractionLocked(false);
            orderMenuUnlockTimeoutRef.current = null;
        }, 220);
    };

    const getComparablePrice = (item: any) => {
        const precoEspecialVenda = Number(item?.preco_especial?.preco_especial_venda) || 0;
        const precoEspecialLocacao = Number(item?.preco_especial?.preco_especial_locacao) || 0;
        const precoVenda = Number(item?.preco_venda) || 0;
        const precoLocacao = Number(item?.preco_locacao) || 0;

        if (type === 'rent') {
            return precoEspecialLocacao || precoLocacao || precoEspecialVenda || precoVenda || 0;
        }

        return precoEspecialVenda || precoVenda || precoEspecialLocacao || precoLocacao || 0;
    };

    const sortFavoritosList = (list: Array<any>) => {
        const favoritesOnly = (list || []).filter((item: any) => favorito?.indexOf(item?.id) !== -1);

        if (!orderActual?.value) {
            return favoritesOnly;
        }

        const [direction, criteria] = String(orderActual.value).split('-');
        const isDesc = direction === 'desc';

        // cs1892 (gate por licença): "Mais Recentes"/"Mais Antigos" nos favoritos = ordem de INCLUSÃO,
        // igual ao backend (imoveis_busca ordena `inclusao` por i.id). O comportamento histórico dos
        // demais sites compara data_edicao (última EDIÇÃO) e, quando a data não parseia, cai no id pra
        // uns e no timestamp pra outros — era o que deixava o link ?favoritos=1,2,3 do CRM em ordem
        // aleatória. Só passa a valer para todos quando o Daniel pedir.
        const FAVORITOS_ORDEM_POR_CADASTRO = new Set([1892]);
        const ordenaFavoritoPorCadastro = FAVORITOS_ORDEM_POR_CADASTRO.has(Number(site?.id ?? codsite));

        const compareByInclusao = (a: any, b: any) => {
            const aId = Number(a?.id) || 0;
            const bId = Number(b?.id) || 0;
            return isDesc ? bId - aId : aId - bId;
        };

        const compareByDate = (a: any, b: any) => {
            const aDate = new Date(a?.data_edicao || 0).getTime() || Number(a?.id) || 0;
            const bDate = new Date(b?.data_edicao || 0).getTime() || Number(b?.id) || 0;
            return isDesc ? bDate - aDate : aDate - bDate;
        };

        const compareByValor = (a: any, b: any) => {
            const diff = getComparablePrice(a) - getComparablePrice(b);
            return isDesc ? -diff : diff;
        };

        const compareByViews = (a: any, b: any) => {
            const diff = (Number(a?.visualizacoes) || 0) - (Number(b?.visualizacoes) || 0);
            return isDesc ? -diff : diff;
        };

        switch (criteria) {
            case 'inclusao':
                return favoritesOnly.slice().sort(ordenaFavoritoPorCadastro ? compareByInclusao : compareByDate);
            case 'valor':
                return favoritesOnly.slice().sort(compareByValor);
            case 'visualizacao':
                return favoritesOnly.slice().sort(compareByViews);
            default:
                return favoritesOnly;
        }
    };

    useEffect(() => {
        return () => {
            clearOrderMenuUnlockTimeout();
        };
    }, []);

    useEffect(() => {
        const empreendimentoId = Number(companyActual?.value || 0);
        const exibeEmpreendimento = Boolean(site?.exibir_empreendimento);

        if (!exibeEmpreendimento || !empreendimentoId) {
            setEmpreendimentoDetalhe(null);
            setEmpreendimentoDetalheLoading(false);
            return;
        }

        let isActive = true;
        setEmpreendimentoDetalheLoading(true);

        getEmpreendimentoById(empreendimentoId, origin, codsite)
            .then((response: any) => {
                if (!isActive) return;
                const empreendimentoResponse = response?.empreendimento || null;
                setEmpreendimentoDetalhe(
                    empreendimentoResponse && isEmpreendimentoVisibleOnSite(empreendimentoResponse?.mostrar_site)
                        ? empreendimentoResponse
                        : null
                );
            })
            .catch(() => {
                if (!isActive) return;
                setEmpreendimentoDetalhe(null);
            })
            .finally(() => {
                if (!isActive) return;
                setEmpreendimentoDetalheLoading(false);
            });

        return () => {
            isActive = false;
        };
    }, [codsite, companyActual?.value, origin, site?.exibir_empreendimento]);

    const empreendimentoResumo = useMemo(() => {
        if (
            !site?.exibir_empreendimento ||
            !Number(companyActual?.value || 0) ||
            !empreendimentoDetalhe?.id ||
            !isEmpreendimentoVisibleOnSite(empreendimentoDetalhe?.mostrar_site)
        ) {
            return null;
        }

        const empreendimento = empreendimentoDetalhe;
        const href = empreendimento?.id ? `/empreendimento/${empreendimento.id}` : '';
        if (!href) {
            return null;
        }

        const cidadeUf = [empreendimento?.cidade, empreendimento?.uf].filter(Boolean).join(' - ');
        const localizacao = [empreendimento?.endereco, empreendimento?.bairro, cidadeUf].filter(Boolean).join(', ');
        const categoria = String(empreendimento?.categoria_empreendimento?.nome || '').trim();
        const caracteristicas = extractEmpreendimentoCaracteristicas(empreendimento);
        const faixaPreco = formatPriceRange(empreendimento?.preco_min, empreendimento?.preco_max);
        const faixaArea = formatAreaRange(
            empreendimento?.area_privativa_min,
            empreendimento?.are_privativa_min,
            empreendimento?.area_privativa_max
        );

        const dormitoriosLabel = formatQtdRange(
            empreendimento?.dormitorios_min,
            empreendimento?.dormitorios_max,
            'dorm',
            'dorms',
            empreendimento?.dormitorios || empreendimento?.suites
        );
        const banheirosLabel = formatQtdRange(
            empreendimento?.banheiros_min,
            empreendimento?.banheiros_max,
            'banheiro',
            'Banheiros',
            empreendimento?.banheiros
        );
        const vagasLabel = formatQtdRange(
            empreendimento?.vagas_min,
            empreendimento?.vagas_max,
            'vaga',
            'Vagas',
            empreendimento?.vagas
        );

        const fotosOrdenadas = Array.isArray(empreendimento?.fotos)
            ? [...empreendimento.fotos].sort((a: any, b: any) => Number(a?.posicao || 0) - Number(b?.posicao || 0))
            : [];
        const fotoDestaque = fotosOrdenadas.find((item: any) => Number(item?.destaque) === 1)?.url_foto;
        const foto = fotoDestaque || getFotoUrlFromFotos(fotosOrdenadas) || fallbackEmpreendimentoImage;
        const highlights = [
            { key: 'dormitorios', icon: 'dormitorios', label: dormitoriosLabel },
            { key: 'area', icon: 'area', label: faixaArea },
            { key: 'banheiros', icon: 'banheiros', label: banheirosLabel },
            { key: 'vagas', icon: 'vagas', label: vagasLabel }
        ].filter((item) => Boolean(item.label));

        return {
            nome: empreendimento?.nome || companyActual?.label || 'Empreendimento',
            href,
            categoria,
            caracteristicas,
            localizacao,
            faixaPreco,
            faixaArea,
            precoMin: parsePositiveNumber(empreendimento?.preco_min),
            precoMax: parsePositiveNumber(empreendimento?.preco_max),
            situacao: formatSituacao(empreendimento?.situacao),
            highlights,
            foto
        };
    }, [companyActual?.label, companyActual?.value, empreendimentoDetalhe, site?.exibir_empreendimento]);
    // 21/10: faixa de preço do empreendimento na moeda do idioma — fora do gate, o texto de sempre.
    const precoVivo = temSeletorIdiomas(site);
    const faixaPrecoVivo = (r: { precoMin: number; precoMax: number; faixaPreco: string }): React.ReactNode => {
        const pm = (v: number) => <PrecoMoeda valor={v} simbolo="R$" original={formatCurrency(v)} />;
        if (r.precoMin > 0 && r.precoMax > 0) return r.precoMin === r.precoMax ? pm(r.precoMin) : <>{pm(r.precoMin)}{' à '}{pm(r.precoMax)}</>;
        if (r.precoMin > 0) return <>{'a partir de '}{pm(r.precoMin)}</>;
        if (r.precoMax > 0) return <>{'até '}{pm(r.precoMax)}</>;
        return r.faixaPreco;
    };

    const onChangeOrder = (txt: any) => {
        setOrderActual(txt);
        closeOrderMenu();
        setPage(1);
        setAutorizaBusca(true);
    };

    const onChangeType = () => {
        if (type === 'sale') {
            if(site?.transacoes[1] == 'Temporada'){
                setType('temporada')
            } else {
                setType('rent');
            }
        }
        if (type === 'rent') {
            if(site?.transacoes[1] == 'Temporada'){
                setType('temporada')
            } else {
                setType('sale');
            }
        }
        if (type === 'temporada') {
            if(site?.transacoes[0] == 'Venda'){
                setType('sale')
            } else {
                setType('rent');
            }
        }
    };

    const onChangeCategory = async (txt: any) => {
        setCategoryActual(txt.value ? txt : 0);
        setPage(1);
        setAutorizaBusca(true);
    };

    const onChangeDatas = (txt: any) => {
        if (!Number(txt.value)) {
            setDataEntregaActual([]);
        } else {
            const existId = dataEntregaActual?.filter(
                (v: any) => v.value === txt.value
            );
            setDataEntregaActual(
                existId.length > 0 ? dataEntregaActual : [...dataEntregaActual, txt]
            );
        }
        setPage(1);
        setAutorizaBusca(true);
    };

    const onChangeCaracteristicas = (txt: any) => {
        if (!Number(txt.value)) {
            setCaractActual([]);
        } else {
            const existId = caractActual?.filter(
                (v: any) => v.value === txt.value
            );
            setCaractActual(
                existId.length > 0 ? caractActual : [...caractActual, txt]
            );
        }
        setPage(1);
        setAutorizaBusca(true);
    };

    const onChangeCity = async (txt: any) => {
        // MULTI-FILIAIS: pode chegar `null` (nenhuma ou 2+ cidades marcadas) —
        // e o react-select também limpa com null. Sem o `?.` isto estourava.
        setCityActual(txt?.value ? txt : null);
        if (txt?.value) {
            setDistrictActual([]);
            const infoDistrict = await district(txt.value, origin, codsite);
            const existValueDefault = listDistrict?.filter(
                (v: any) => !v.value
            );
            if (!existValueDefault.length) {
                setListDistrict(formatSelects(infoDistrict?.bairros));
            } else {
                setListDistrict(formatSelects(infoDistrict?.bairros));
            }
        }
        setPage(1);
        setAutorizaBusca(true);
    };

    // MULTI-FILIAIS: no modo popup o select de CIDADES aceita 1..N (mesma
    // mecânica do select de bairro) — e nos modelos novos (`localMulti`). Fora
    // disso, selectProps é {} e nada muda.
    const cidadesMulti = useCidadesMulti(onChangeCity, listCity, !!localMulti);
    const cidadesSeedFeitoRef = useRef(false);
    useEffect(() => {
        if (cidadesSeedFeitoRef.current) return;
        if (!Array.isArray(cidadesSeed) || !cidadesSeed.length) return;
        if (!Array.isArray(listCity) || !listCity.length) return;
        cidadesSeedFeitoRef.current = true;
        cidadesMulti.semearPorIds(cidadesSeed, listCity);
    }, [cidadesSeed, listCity, cidadesMulti.semearPorIds]);
    useEffect(() => {
        onCidadesMulti?.(cidadesMulti.ids);
    }, [cidadesMulti.ids, onCidadesMulti]);

    // cs834 e modelos novos (utils/buscaMultiSelecao): com 2+ cidades marcadas o select de BAIRROS oferece os
    // bairros de TODAS elas (antes ficava só com os da 1ª, que a ponte de cidade única carregou).
    // Bairro marcado de cidade que saiu da seleção sai junto; os que ficam passam ao rótulo da
    // união ("Centro (CAMPO BOM)" quando o nome se repete) — o mesmo que a URL lê na volta.
    const districtActualRef = useRef<any[]>(districtActual);
    districtActualRef.current = districtActual;
    const cidadesMultiChave = localMulti && cidadesMulti.multiAtivo ? cidadesMulti.ids.join(',') : '';
    useEffect(() => {
        if (!cidadesMultiChave) return;
        let vivo = true;
        const ids = cidadesMultiChave.split(',').map(Number);
        Promise.all(ids.map((id) => district(id, origin, codsite).catch(() => null))).then((respostas) => {
            if (!vivo) return;
            const lista = uniaoBairrosDasCidades(respostas, listCity);
            setListDistrict(lista);
            const atuais = Array.isArray(districtActualRef.current) ? districtActualRef.current : [];
            if (!atuais.length) return;
            const marcados = new Set(atuais.map((b: any) => Number(b?.value)));
            const ficam = lista.filter((b) => marcados.has(Number(b.value)));
            const mudou = ficam.length !== atuais.length || ficam.some((b) => !atuais.some((a: any) => Number(a?.value) === b.value && a?.label === b.label));
            if (mudou) {
                setDistrictActual(ficam);
                setPage(1);
                setAutorizaBusca(true);
            }
        });
        return () => { vivo = false; };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cidadesMultiChave]);
    // cs834: os chips de cidade saem da seleção do select multi. A cidade única posta de FORA da
    // ponte (caminho da URL) entra nela; e o "x" tira a cidade da seleção — zerar só o cityActual
    // deixava a cidade marcada no hook e a busca continuava filtrando por ela.
    const cidadesChipsMulti = !!localMulti && cidadesMulti.habilitado;
    useEffect(() => {
        if (!cidadesChipsMulti) return;
        const v = Number(cityActual?.value);
        if (v > 0) {
            if (cidadesMulti.ids.length < 2 && !cidadesMulti.ids.includes(v)) cidadesMulti.semearPorIds([v], listCity);
        } else if (cidadesMulti.ids.length === 1) {
            // cidade única zerada por fora (a ponte só zera o cityActual com 0 ou 2+ marcadas)
            cidadesMulti.setCidades([]);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cidadesChipsMulti, cityActual?.value, listCity]);
    const removerCidadeMulti = (valor: any) => {
        const resto = cidadesMulti.cidades.filter((c) => Number(c?.value) !== Number(valor));
        if (!resto.length) {
            setDistrictActual([]);
            setListDistrict([]);
        }
        cidadesMulti.setCidades(resto);
    };

    // cs2065: País e Estado em dois selects (utils/filtroPais). Com país escolhido, o select de
    // Estado só oferece os estados dele.
    const filtroPais = temFiltroPais(site?.id);
    const estadosVisiveis = useMemo(
        () => (filtroPais && paisActual?.value ? estadosDoPais(listEstados, paisActual.value) : listEstados),
        [filtroPais, listEstados, paisActual?.value]
    );
    // Cidades que o select oferece quando NÃO há estado escolhido: as do país (ou todas).
    const cidadesSemEstado = () => (filtroPais ? cidadesDoPais(allCities, listEstados, paisActual?.value) : allCities);

    const onChangeEstados = async (txt: any) => {
        setEstadoActual(txt.value ? txt : 0);
        // cs2065: o País acompanha o estado escolhido.
        if (filtroPais) setPaisActual?.(paisDoEstado(listEstados, txt?.value) || paisActual);

        const cidadesFiltradas = allCities.filter(
            city => city?.id_estado === txt.value
        );

        setDistrictActual([]);
        setListDistrict([]);
        setCityActual(null);
        setListCity(cidadesFiltradas);
        setPage(1);
        setAutorizaBusca(true);
    };

    // cs2065: trocar o País limpa o Estado que não é dele e deixa só as cidades do país.
    // `null` = tirar o filtro de país (e o estado junto — o estado é "dentro" do país).
    const onChangePais = (txt: any) => {
        const pais = txt?.value ? txt : null;
        setPaisActual?.(pais);
        const estadoFica = Boolean(
            pais && estadoActual?.value && paisDoEstado(listEstados, estadoActual.value)?.value === pais.value
        );
        if (!estadoFica) setEstadoActual(null);
        setDistrictActual([]);
        setListDistrict([]);
        setCityActual(null);
        setListCity(
            estadoFica
                ? allCities.filter((city) => city?.id_estado === estadoActual.value)
                : cidadesDoPais(allCities, listEstados, pais?.value)
        );
        setPage(1);
        setAutorizaBusca(true);
    };

    const onChangeDistrict = (txt: any) => {
        if (Array.isArray(txt)) {
            const hasInvalid = txt.some((opt) => !Number(opt?.value));
            if (hasInvalid) {
                setDistrictActual([]);
            } else {
                setDistrictActual(txt);
            }
            setPage(1);
            setAutorizaBusca(true);
            return;
        }
        if (!Number(txt?.value)) {
            setDistrictActual([]);
        } else {
            const existId = districtActual?.filter(
                (v: any) => v.value === txt.value
            );
            setDistrictActual(
                existId.length > 0 ? districtActual : [...districtActual, txt]
            );
        }
        setPage(1);
        setAutorizaBusca(true);
    };

    const onChangeTypes = (txt: any) => {
        if (Array.isArray(txt)) {
            const hasInvalid = txt.some((opt) => !Number(opt?.value));
            if (hasInvalid) {
                setTypeActual([]);
            } else {
                setTypeActual(txt);
            }
            setPage(1);
            setAutorizaBusca(true);
            return;
        }
        if (!Number(txt?.value)) {
            setTypeActual([]);
        } else {
            const existId = typeActual?.filter(
                (v: any) => v.value === txt.value
            );
            setTypeActual(
                existId.length > 0 ? typeActual : [...typeActual, txt]
            );
        }
        setPage(1);
        setAutorizaBusca(true);
    };

    const onChangeCompany = (txt: any) => {
        setCompanyActual(txt.value ? txt : 0);
        setPage(1);
        setAutorizaBusca(true);
    };

    // cs834 (utils/buscaMultiSelecao): CONDOMÍNIOS e CATEGORIAS com várias opções — mesma ponte
    // das cidades (useSelecaoMulti): 1 marcado = o escalar de sempre; 2+ = lista para a página.
    // Fora do gate, selectProps = {} e selecionados = [] (nada muda).
    const condominiosMulti = useSelecaoMulti({
        habilitado: !!buscaMulti,
        valorUnico: companyActual,
        onChangeUnico: onChangeCompany,
        onIds: onCondominiosMulti,
        singular: 'condomínio',
        plural: 'condomínios',
        vazio: 'Condomínios',
    });
    const categoriasMulti = useSelecaoMulti({
        habilitado: !!buscaMulti,
        valorUnico: categoryActual,
        onChangeUnico: onChangeCategory,
        onIds: onCategoriasMulti,
        singular: 'categoria',
        plural: 'categorias',
        feminino: true,
        vazio: 'Categorias',
    });
    // `?condominios=`/`?categorias=` da URL marcam o select assim que as opções chegam (1x cada).
    const filtrosMultiSemeadosRef = useRef({ condominios: false, categorias: false });
    useEffect(() => {
        if (!buscaMulti) return;
        const feito = filtrosMultiSemeadosRef.current;
        if (!feito.condominios && (condominiosSeed?.length || 0) >= 2 && Array.isArray(listCompany) && listCompany.length) {
            feito.condominios = true;
            condominiosMulti.semearPorIds(condominiosSeed || [], listCompany);
        }
        if (!feito.categorias && (categoriasSeed?.length || 0) >= 2 && Array.isArray(listCategory) && listCategory.length) {
            feito.categorias = true;
            categoriasMulti.semearPorIds(categoriasSeed || [], listCategory);
        }
    }, [buscaMulti, condominiosSeed, categoriasSeed, listCompany, listCategory, condominiosMulti.semearPorIds, categoriasMulti.semearPorIds]);
    // "Ver todos os imóveis" da página: desmarca as listas (o escalar ela mesma já zerou).
    const zeraMultiTokenRef = useRef(zeraMultiToken);
    useEffect(() => {
        if (zeraMultiTokenRef.current === zeraMultiToken) return;
        zeraMultiTokenRef.current = zeraMultiToken;
        condominiosMulti.limpar();
        categoriasMulti.limpar();
        if (cidadesMulti.cidades.length) cidadesMulti.setCidades([]);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [zeraMultiToken]);

    const onChangeCode = (e: React.ChangeEvent<HTMLInputElement>) => {
        setCodeInput(e.target.value);
    };

    useEffect(() => {
        if(codeInput){
            const handler = setTimeout(() => {
                setCodeActual(codeInput);
                setPage(1);
                setAutorizaBusca(true);
            }, 2000);

            return () => clearTimeout(handler); // limpa timeout se digitar de novo
        }

    }, [codeInput]);

    // cs834 (utils/buscaMultiSelecao): a RÉGUA de venda começa no piso (R$ 500 mil). Só o desenho
    // e o que o visitante escolhe: sem ele mexer, `price` segue a faixa do tenant e a lista vem
    // inteira; mexeu (régua, mínimo ou máximo), nada fica abaixo do piso. Sem piso, tudo igual.
    const pisoRegua = type === 'sale' ? pisoPrecoVenda(site?.id, filterPrice?.max) : 0;
    const reguaMin = pisoRegua ? Math.max(Number(filterPrice?.min) || 0, pisoRegua) : filterPrice?.min;
    const naRegua = (v: number) => (pisoRegua ? Math.max(Number(v) || 0, reguaMin) : v);
    const precoRegua = pisoRegua && Array.isArray(imput_price)
        ? [naRegua(imput_price[0]), naRegua(imput_price[1])]
        : imput_price;
    // campo em edição mostra o que está sendo digitado (o piso só entra ao confirmar)
    const [precoEmEdicao, setPrecoEmEdicao] = useState(false);
    const propsCampoPreco = pisoRegua
        ? {
            onFocus: () => {
                setPrecoEmEdicao(true);
                setImput_price(precoRegua);
            },
            onBlur: () => setPrecoEmEdicao(false),
        }
        : {};

    const onChangeMinimo = (e: React.ChangeEvent<HTMLInputElement>) => {
        const val = Number(e.target.value.replace(/\D/g, ''));  // só números

        // a) atualiza UI instantaneamente
        setImput_price([val, imput_price[1]]);

        // b) reinicia debounce
        if (timerRef.current) clearTimeout(timerRef.current);
            timerRef.current = setTimeout(() => {
            if (pisoRegua) {
                const minimo = naRegua(val);
                const maximo = Math.max(minimo, Number(price[1]) || minimo);
                setPrice([minimo, maximo]);
                setImput_price([minimo, maximo]);
                setPage(1);
                setAutorizaBusca(true);
                timerRef.current = null;
                return;
            }
            if (val >= 0 && val < price[1]) {
                setPrice([val, price[1]]);            // ← só depois de 1 s
                setPage(1);
                setAutorizaBusca(true);
            } else {
                setPrice([val, val]);  
                setImput_price([val, val]);
                setPage(1);
                setAutorizaBusca(true);
            }
            timerRef.current = null;
        }, DEBOUNCE_MS);
    };

    const onChangeMaximo = (e: React.ChangeEvent<HTMLInputElement>) => {
        // remove qualquer caractere não numérico
        const val = Number(e.target.value.replace(/\D/g, ''));

        setImput_price([imput_price[0], val]);

        // 2) reinicia o debounce para o estado global
        if (timerRef.current) clearTimeout(timerRef.current);
        timerRef.current = setTimeout(() => {
            if (pisoRegua) {
                const maximo = naRegua(val);
                const minimo = Math.min(naRegua(Number(imput_price[0]) || 0), maximo);
                setPrice([minimo, maximo]);
                setImput_price([minimo, maximo]);
                setPage(1);
                setAutorizaBusca(true);
                timerRef.current = null;
                return;
            }
            if (val >= 0 && val < price[0]) {
                setPrice([val, val]);  
                setImput_price([val, val]);   
                setPage(1);  
                setAutorizaBusca(true);      
            } else {
                setPrice([imput_price[0], val]); 
                setPage(1);
                setAutorizaBusca(true);
            }
            timerRef.current = null;
        }, DEBOUNCE_MS);
    };

    const onChangeAreaMinimo = (txt: React.ChangeEvent<HTMLInputElement>) => {
        const value: number = Number(txt.target.value);
        setAreaAux([value,areaAux[1]])
        if (timerRef.current) clearTimeout(timerRef.current);
            timerRef.current = setTimeout(() => {
                if(value>=0 && value<=areaAux[1]){
                    setArea([value,areaAux[1]])
                    setAreaAux([value,areaAux[1]])
                    setPage(1);
                    setAutorizaBusca(true);
                } else {
                    if(value>=0){
                        setArea([value,value])
                        setAreaAux([value,value])
                        setPage(1);
                        setAutorizaBusca(true);
                    }
                 }
                timerRef.current = null;
        }, DEBOUNCE_MS);
    };

    const onChangeAreaMaximo = (txt: React.ChangeEvent<HTMLInputElement>) => {
        const value: number = Number(txt.target.value);
        setAreaAux([areaAux[0],value])
        if (timerRef.current) clearTimeout(timerRef.current);
            timerRef.current = setTimeout(() => {
                 if(value>=0 && value >= areaAux[0]){
                    setArea([areaAux[0],value])
                    setAreaAux([areaAux[0],value])
                    setPage(1);
                    setAutorizaBusca(true);
                } else {
                    if(value>=0){
                        setArea([0,value])
                        setAreaAux([0,value])
                        setPage(1);
                        setAutorizaBusca(true);
                    }
                }
            timerRef.current = null;
        }, DEBOUNCE_MS);
    };

    const onInputChangeCompany = (txt: any) => {
        setCompanyInputActual(txt);
    };

    const limpaFavoritos = () => {
        window.localStorage.removeItem('favoritos');
        setFavorito([])
        setOpenFavoritos(false)
        setPage(1);
        setAutorizaBusca(true);
    };

    // 3️⃣ ref para guardar o timer
    const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

    /* ---------- handlers ---------- */

    // muda só a UI (movimento fluido) e respeita o minDistance
    // refs de controle
    const isUserSlidingRef = useRef(false);     // verdadeiro apenas durante interação do usuário no slider
    const suppressCommitRef = useRef(false);    // verdadeiro quando vamos atualizar preço programaticamente

    // NOVOS refs
    const commitSeqRef = useRef(0);             // token p/ invalidar timeouts antigos

    // helper p/ cancelar qualquer commit/timeout pendente
    const cancelPendingPriceCommit = () => {
    if (timerRef.current) clearTimeout(timerRef.current);
        timerRef.current = null;
        isUserSlidingRef.current = false;
        commitSeqRef.current++; // invalida timeouts já agendados
    };

   const handleChangePrice = (
    _: Event | React.SyntheticEvent<Element, Event>,
    newValue: number | number[],
    activeThumb: number,
    ) => {
        if (!Array.isArray(newValue)) return;

        // interação do usuário começou
        isUserSlidingRef.current = true;

        let next = newValue;
        if (next[1] - next[0] < minDistance) {
            if (activeThumb === 0) {
            next = [Math.min(next[0], filterPrice.max - minDistance), next[0] + minDistance];
            } else {
            next = [next[1] - minDistance, Math.max(next[1], reguaMin + minDistance)];
            }
        }
        setImput_price(next);
    };

    useEffect(() => () => cancelPendingPriceCommit(), []);

    useEffect(() => {
        if (!Array.isArray(price) || isUserSlidingRef.current) return;

        const nextPrice: [number, number] = [
            Number(price[0] || 0),
            Number(price[1] || 0)
        ];
        const currentPrice = Array.isArray(imput_price) ? imput_price : [];
        if (currentPrice[0] !== nextPrice[0] || currentPrice[1] !== nextPrice[1]) {
            setImput_price(nextPrice);
        }
    }, [price]);

    const handleCommitted = (
        _: Event | React.SyntheticEvent<Element, Event>,
        newValue: number | number[],
    ) => {
        // ignora se foi update programático ou sem interação real
        if (suppressCommitRef.current || !isUserSlidingRef.current || !Array.isArray(newValue)) return;

        isUserSlidingRef.current = false;

        // gera token para este commit
        const mySeq = ++commitSeqRef.current;

        // reinicia debounce
        if (timerRef.current) clearTimeout(timerRef.current);
        timerRef.current = setTimeout(() => {
            // se outro evento invalidou este commit, sai
            if (mySeq !== commitSeqRef.current) return;

            setPrice(newValue);
            setPage(1);
            setAutorizaBusca(true);
            timerRef.current = null;
        }, DEBOUNCE_MS);
    };

    const GetFilterPrice = async () => {
        let getFilter = valores;
        const newFilter = () => {
            if (type === 'rent') return getFilter?.precos_locacao[0];
            if (type === 'sale') return getFilter?.precos_venda[0];
            if (type === 'temporada') {
            if (getFilter?.precos_locacao[0]?.max)
                return { min: 0, max: getFilter?.precos_locacao[0]?.max };
            return { min: 0, max: getFilter?.precos_venda[0]?.max };
            }
            return null;
        };

        const getFiltersPrices = await newFilter();

        // cs2422 (toc2imoveis): mesmo gate da página. Aqui ficava o SEGUNDO descarte do preço
        // escolhido — estar fora dos limites do tenant bastava para o filtro voltar à faixa
        // inteira, e a busca listava tudo. Neste tenant o valor escolhido manda: os limites do
        // Slider é que crescem para caber a escolha.
        const respeitaPrecoDigitado = [2422, 2617].includes(Number(site?.id));
        const escolhaAtual = Array.isArray(price) ? price : [];
        const limitesSlider = respeitaPrecoDigitado && getFiltersPrices
            ? {
                min: Number.isFinite(Number(escolhaAtual[0]))
                    ? Math.min(Number(getFiltersPrices?.min), Number(escolhaAtual[0]))
                    : getFiltersPrices?.min,
                max: Number.isFinite(Number(escolhaAtual[1]))
                    ? Math.max(Number(getFiltersPrices?.max), Number(escolhaAtual[1]))
                    : getFiltersPrices?.max,
            }
            : getFiltersPrices;

        if (filterPrice?.min !== limitesSlider?.min || filterPrice?.max !== limitesSlider?.max) {
            setFilterPrice(!limitesSlider?.min && !limitesSlider?.max ? { min: 0, max: 0 } : limitesSlider);
        }

        const foraDosLimites =
            Number(escolhaAtual[0]) < getFiltersPrices?.min ||
            Number(escolhaAtual[1]) > getFiltersPrices?.max;
        const hasInvalidPrice =
            !Array.isArray(price) ||
            price[0] === undefined ||
            price[1] === undefined ||
            Number(price[0]) > Number(price[1]) ||
            (!respeitaPrecoDigitado && foraDosLimites) ||
            (Number(price[0]) === 0 && Number(price[1]) === 0 && Number(getFiltersPrices?.max) > 0);

        const typeChanged = type != lastType;

        if (typeChanged && getFiltersPrices) {
            setLastType(type)
            suppressCommitRef.current = true;

            setImput_price([getFiltersPrices.min, getFiltersPrices.max]);
            setPrice([getFiltersPrices.min, getFiltersPrices.max]);
            setPage(1);
            setAutorizaBusca(true);

            setTimeout(() => { suppressCommitRef.current = false; }, 0);
            return;
        }

        if (hasInvalidPrice && getFiltersPrices) {
            suppressCommitRef.current = true;
            
            setImput_price([getFiltersPrices.min, getFiltersPrices.max]);
            setPrice([getFiltersPrices.min, getFiltersPrices.max]);
            setPage(1);
            setAutorizaBusca(true);

            // libera no próximo tick
            setTimeout(() => { suppressCommitRef.current = false; }, 0);
        }
    };

    const GetAgenciadorId = async () => {
        if (agenciador && agenciador != undefined ) {
            const GetManager = await getManagerId(Number(agenciador), origin, codsite);
            if(GetManager?.parceiros?.length > 0){
                setManagerActual(GetManager?.parceiros[0]);
                setStatus('valid');
            }
        }
    }

    const openFilter = () => {
        closeOrderMenu();
        setActiveLargeFilter(true);
    };

    useEffect(() => {
        if (!openFavoritos) return;
        if (!setAllProperties) return;

        if(favorito?.length == 0 && !loading){
            limpaFavoritos();
            return;
        }

        const sortedFavorites = sortFavoritosList(allProperties || []);

        const sameOrder =
            sortedFavorites.length === (allProperties?.length || 0) &&
            sortedFavorites.every((item: any, index: number) => item?.id === allProperties?.[index]?.id);

        if (!sameOrder) {
            setAllProperties(sortedFavorites);
        }
    }, [allProperties, favorito, openFavoritos, orderActual, loading]);

    useEffect(() => {
        cancelPendingPriceCommit();
        if (typeValidation && first) {
            GetFilterPrice();
        }
    }, [type, typeValidation]);

    useEffect(() => {
        if (size?.width > 900 && typeValidation) {
            setActiveLargeFilter(false);
        }
    }, [size?.width]);

    useEffect(() => {
        if (!activeLargeFilter) return;
        closeOrderMenu();
    }, [activeLargeFilter]);

    useEffect(() => {
        GetAgenciadorId();
    }, [agenciador]);

    const renderFilters = () => {
        return (
            <>
                {typeValidation ? (
                    <motion.div
                        key="topo"
                        initial={{ opacity: 0, y: 50 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5, delay: 0.1 }}
                        className={styles.container_filter}
                        data-nosnippet
                        style={legado({background: corFundo,border: `1px solid ${hexToRgba(corLetra1,0.5)}`})}
                    >
                        <div className={styles.adjust_header_tabs}>
                            { site?.transacoes?.length > 1 ?
                                <>
                                    <button
                                        aria-label="Botão para buscar imóveis de venda"
                                        title="Clique aqui para buscar imóveis para venda"
                                        type="button"
                                        className={
                                            type === 'sale'
                                                ? styles.header_tab_focus
                                                : styles.header_tab
                                        }
                                        style={legado(type === 'sale' ? {background: site?.cor2,color: isColorLight(site?.cor2) ? site?.cor11 : site?.cor13} : {background: "none",color: corLetra1})}
                                        onClick={() => setType('sale')}
                                    >
                                        Comprar
                                    </button>
                                    { site?.transacoes[1] == 'Temporada' ?
                                        <button
                                            aria-label="Botão para buscar imóveis de temporada"
                                            title="Clique aqui para buscar imóveis para temporada"
                                            type="button"
                                            className={
                                                type === 'temporada'
                                                    ? styles.header_tab_focus
                                                    : styles.header_tab
                                            }
                                            style={legado(type === 'temporada' ? {background: site?.cor2,color: isColorLight(site?.cor2) ? site?.cor11 : site?.cor13} : {background: "none",color: corLetra1})}
                                            onClick={() => setType('temporada')}
                                            >
                                            Temporada
                                        </button>
                                    :
                                        <button
                                            aria-label="Botão para buscar imóveis de aluguel"
                                            title="Clique aqui para buscar imóveis para alugar"
                                            type="button"
                                            className={
                                                type === 'rent'
                                                    ? styles.header_tab_focus
                                                    : styles.header_tab
                                            }
                                            style={legado(type === 'rent' ? {background: site?.cor2,color: isColorLight(site?.cor2) ? site?.cor11 : site?.cor13} : {background: "none",color: corLetra1})}
                                            onClick={() => setType('rent')}
                                        >
                                            Alugar
                                        </button>
                                    }
                                </>
                            : null }
                            { site?.transacoes?.length > 2 ?
                                <button
                                    aria-label="Botão para buscar imóveis para temporada"
                                    title="Clique aqui para buscar imóveis de temporada"
                                    type="button"
                                    style={legado(type === 'temporada' ? {background: site?.cor2,color: isColorLight(site?.cor2) ? site?.cor11 : site?.cor13} : {background: "none",color: corLetra1})}
                                    className={
                                        type === 'temporada'
                                            ? styles.header_tab_focus
                                            : styles.header_tab
                                    }
                                    onClick={() => setType('temporada')}
                                >
                                    Temporada
                                </button> : null
                            }
                        </div>
                        <div className={styles.adjust_slider}>
                            {<div className={styles.adjust_select_price}>
                                    <label className={styles.title_select} style={{color: corLetra1}}>
                                        PREÇOS
                                    </label>
                                    <div className={styles.adjust_prices}>
                                        <label className={styles.price} style={{color: corLetra1}}>
                                            {`${site?.moeda_tipo} ${toPrice(precoRegua[0] ||
                                                Number(
                                                    Number(
                                                        (filterPrice?.max) *
                                                            ((precoRegua?.length > 0
                                                                ? precoRegua[0]
                                                                : 0) /
                                                                100)
                                                    )
                                                ),
                                                2
                                            )}`}
                                        </label>
                                        <label className={styles.price} style={{color: corLetra1}}>
                                            {`${site?.moeda_tipo} ${toPrice(precoRegua[1] ||
                                                Number(
                                                    Number(
                                                        (filterPrice?.max) *
                                                            ((precoRegua?.length > 0
                                                                ? precoRegua[1]
                                                                : 0) /
                                                                100)
                                                    )
                                                ),
                                                2
                                            )}`}
                                        </label>
                                    </div>

                                    <Slider
                                        value={precoRegua || [0,100]}
                                        onChange={handleChangePrice}
                                        onChangeCommitted={handleCommitted}
                                        disableSwap
                                        min={reguaMin}
                                        max={filterPrice?.max}
                                        step={1000}
                                        style={horizonte ? { color: corAcentoHz } : coresAP ? { color: coresAP.painelAcento } : coresLr ? { color: coresLr.base } : coresMt ? { color: coresMt.acento } : coresIn ? { color: coresIn.base } : coresNt ? { color: coresNt.tinta } : coresCp ? { color: coresCp.tinta } : {
                                            color: isColorLight(site?.cor5) ? isColorLight(site?.cor2) ? corLetra1 : site?.cor2 : corLetra1,
                                        }}
                                    />
                                </div>
                            }
                        </div>
                        <div className={styles.adjust_select_p}>
                            <div className={styles.adjust_select_price1} style={{margin: "0px 2.5% 0px 0px"}}>
                                <label className={styles.title_select} style={{color: corLetra1}}>
                                    MÍNIMO
                                </label>
                                <input
                                    className={styles.input}
                                    placeholder={imput_price ? "R$ "+imput_price[0] : "Valor mínimo"}
                                    onChange={onChangeMinimo}
                                    inputMode='numeric'
                                    value={pisoRegua && !precoEmEdicao ? precoRegua[0] : imput_price[0]}
                                    {...propsCampoPreco}
                                    style={legado({ color: corLetra1,border: `2px solid ${corLetra1}` })}
                                />
                            </div>
                            <div className={styles.adjust_select_price1} style={{margin: "0px 0px 0px 2.5%"}}>
                                <label className={styles.title_select} style={{color: corLetra1}}>
                                    MÁXIMO
                                </label>
                                <input
                                    className={styles.input}
                                    placeholder={imput_price ? "R$ "+imput_price[1] : "Valor Máximo"}
                                    onChange={onChangeMaximo}
                                    inputMode='numeric'
                                    value={pisoRegua && !precoEmEdicao ? precoRegua[1] : imput_price[1]}
                                    {...propsCampoPreco}
                                    style={legado({ color: corLetra1,border: `2px solid ${corLetra1}` })}
                                />
                            </div>
                        </div>
                        {filtroPais && listPaises?.length > 0 ?
                        <div className={styles.adjust_select}>
                            <label htmlFor="filtro-pais-input" className={styles.title_select} style={{color: corLetra1}}>
                                PAÍS
                            </label>
                            <Select
                                inputId="filtro-pais-input"
                                options={listPaises}
                                className={styles.select}
                                placeholder="País"
                                noOptionsMessage={() => 'País não encontrado!'}
                                styles={colorPicker}
                                value={paisActual}
                                onChange={onChangePais}
                                instanceId="filtro-pais"
                            />
                        </div> : null}
                        {filtroPais && paisActual?.value ? (
                            <div className={styles.adjust_tags_filter}>
                                <button
                                    aria-label={`Botão para remover filtro de país ${paisActual?.label}`}
                                    title={`Clique para remover filtro de país ${paisActual?.label}`}
                                    type="button"
                                    className={styles.tags_picker}
                                    onClick={() => onChangePais(null)}
                                    style={stylesTags2}
                                >
                                    {paisActual?.label}
                                    <IoCloseSharp
                                        size={16}
                                        color={stylesIconClose}
                                        style={marginIconTag}
                                    />
                                </button>
                            </div>
                        ) : null}
                        {(site?.id == 2177 || site?.id == 2297 || site?.id == 1942 || site?.id == 2065) && listEstados ?
                        <div className={styles.adjust_select}>
                            <label className={styles.title_select} style={{color: corLetra1}}>
                                ESTADO
                            </label>
                            <Select
                                options={estadosVisiveis}
                                className={styles.select}
                                placeholder="Estado"
                                noOptionsMessage={() => 'Estado não encontrado!'}
                                styles={colorPicker}
                                value={estadoActual}
                                onChange={onChangeEstados}
                                instanceId={0}
                            />
                        </div> : null}
                        {estadoActual && (site?.id == 2177 || site?.id == 2297 || site?.id == 1942 || site?.id == 2065) ? (
                            <div className={styles.adjust_tags_filter}>
                                <button
                                    aria-label={`Botão para remover filtro de estado ${estadoActual?.label}`}
                                    title={`Clique para remover filtro de estado ${estadoActual?.label}`}
                                    type="button"
                                    className={styles.tags_picker}
                                    onClick={() => {
                                        setDistrictActual([]);
                                        setListDistrict([]);
                                        setCityActual(null);
                                        setListCity(cidadesSemEstado());
                                        setEstadoActual(null);
                                        setPage(1);
                                        setAutorizaBusca(true);
                                    }}
                                    style={stylesTags2}
                                >
                                    {estadoActual?.label}
                                    <IoCloseSharp
                                        size={16}
                                        color={stylesIconClose}
                                        style={marginIconTag}
                                    />
                                </button>
                            </div>
                        ) : null}
                        <div className={styles.adjust_select}>
                            <label className={styles.title_select} style={{color: corLetra1}}>
                                CIDADES
                            </label>
                            <Select
                                options={listCity}
                                className={styles.select}
                                placeholder="Cidades"
                                noOptionsMessage={() => 'Cidade não encontrada!'}
                                styles={colorPicker}
                                value={cityActual}
                                onChange={onChangeCity}
                                instanceId={0}
                                {...cidadesMulti.selectProps}
                            />
                        </div>
                        {cidadesChipsMulti ? (
                            cidadesMulti.cidades.length > 0 ? (
                                <div className={styles.adjust_tags_filter}>
                                    {cidadesMulti.cidades.map((v: any) => (
                                        <button
                                            aria-label={`Botão para remover filtro da cidade ${v?.label}`}
                                            title={`Clique para remover filtro da cidade ${v?.label}`}
                                            type="button"
                                            className={styles.tags_picker}
                                            onClick={() => removerCidadeMulti(v?.value)}
                                            key={v?.value}
                                            style={stylesTags2}
                                        >
                                            {v?.label}
                                            <IoCloseSharp
                                                size={16}
                                                color={stylesIconClose}
                                                style={marginIconTag}
                                            />
                                        </button>
                                    ))}
                                </div>
                            ) : null
                        ) : cityActual ? (
                            <div className={styles.adjust_tags_filter}>
                                <button
                                    aria-label={`Botão para remover filtro da cidade ${cityActual?.label}`}
                                    title={`Clique para remover filtro da cidade ${cityActual?.label}`}
                                    type="button"
                                    className={styles.tags_picker}
                                    onClick={() => {
                                        setDistrictActual([]);
                                        setListDistrict([]);
                                        setCityActual(null);
                                        setPage(1);
                                        setAutorizaBusca(true);
                                    }}
                                    style={stylesTags2}
                                >
                                    {cityActual?.label}
                                    <IoCloseSharp
                                        size={16}
                                        color={stylesIconClose}
                                        style={marginIconTag}
                                    />
                                </button>
                            </div>
                        ) : null}
                        <div className={styles.adjust_select}>
                            <label className={styles.title_select} style={{color: corLetra1}}>
                                BAIRROS
                            </label>
                            <Select
                                options={listDistrict}
                                className={styles.select}
                                placeholder={
                                    formatSelectedCount(districtActual, 'bairro', 'bairros') || 'Bairros'
                                }
                                noOptionsMessage={() => 'Bairro não encontrado!'}
                                styles={colorPicker}
                                isMulti
                                closeMenuOnSelect
                                controlShouldRenderValue={false}
                                hideSelectedOptions={false}
                                isClearable={false}
                                components={{ ClearIndicator: null }}
                                value={districtActual}
                                onChange={onChangeDistrict}
                                instanceId={1}
                            />
                        </div>
                        {districtActual?.length > 0 ? (
                            <div className={styles.adjust_tags_filter}>
                                {districtActual?.map((v: any) => {
                                    const removeDistrict = () => {
                                        const removeUnique =
                                            districtActual?.filter(
                                                (e: any) =>
                                                    e?.value !== v?.value
                                            );
                                        setDistrictActual(removeUnique);
                                        setPage(1);
                                        setAutorizaBusca(true);
                                    };
                                    return (
                                        <button
                                            aria-label={`Botão para remover filtro do bairro ${v?.label}`}
                                            title={`Clique para remover filtro do bairro ${v?.label}`}
                                            type="button"
                                            className={styles.tags_picker}
                                            onClick={removeDistrict}
                                            key={v?.value}
                                            style={stylesTags2}
                                        >
                                            {v?.label}
                                            <IoCloseSharp
                                                size={16}
                                                color={stylesIconClose}
                                                style={marginIconTag}
                                            />
                                        </button>
                                    );
                                })}
                            </div>
                        ) : null}
                        <div className={styles.adjust_select}>
                            <label className={styles.title_select} style={{color: corLetra1}}>TIPOS</label>
                            <Select
                                options={listType}
                                className={styles.select}
                                placeholder={
                                    formatSelectedCount(typeActual, 'tipo', 'tipos') || 'Tipos'
                                }
                                noOptionsMessage={() => 'Tipo não encontrado!'}
                                styles={colorPicker}
                                isMulti
                                closeMenuOnSelect
                                controlShouldRenderValue={false}
                                hideSelectedOptions={false}
                                isClearable={false}
                                components={{ ClearIndicator: null }}
                                value={typeActual}
                                onChange={onChangeTypes}
                                instanceId={2}
                            />
                        </div>
                        {typeActual?.length > 0 ? (
                            <div className={styles.adjust_tags_filter}>
                                {typeActual?.map((v: any) => {
                                    const removeType = () => {
                                        const removeUnique = typeActual?.filter(
                                            (e: any) => e?.value !== v?.value
                                        );
                                        setTypeActual(removeUnique);
                                        setPage(1);
                                        setAutorizaBusca(true);
                                    };
                                    return (
                                        <button
                                            aria-label={`Botão para remover filtro do tipo ${v?.label}`}
                                            title={`Clique para remover filtro dos tipo ${v?.label}`}
                                            type="button"
                                            className={styles.tags_picker}
                                            onClick={removeType}
                                            key={v?.value}
                                            style={stylesTags2}
                                        >
                                            {v?.label}
                                            <IoCloseSharp
                                                size={16}
                                                color={stylesIconClose}
                                                style={marginIconTag}
                                            />
                                        </button>
                                    );
                                })}
                            </div>
                        ) : null}
                        { site?.exibir_empreendimento ?
                            <div className={styles.adjust_select}>
                                <label className={styles.title_select} style={{color: corLetra1}}>
                                    {site?.id == "1892" ? "RESIDENCIAIS E LOTEAMENTOS" : isSite2587 ? "CONDOMÍNIO/EMPREENDIMENTO" : "CONDOMÍNIOS"}
                                </label>
                                <Select
                                    options={listCompany}
                                    className={styles.select}
                                    placeholder={site?.id == "1892" ? "Residenciais e loteamentos" : isSite2587 ? "Condomínio/Empreendimento" : "Condomínios"}
                                    styles={colorPickerCompany}
                                    value={companyActual}
                                    onChange={onChangeCompany}
                                    noOptionsMessage={() =>
                                        isSite2587
                                            ? (companyInputActual ? 'Empreendimento não encontrado' : 'Busque por um condomínio ou empreendimento')
                                            : (companyInputActual ? 'Condomínio não encontrado' : 'Busque por um condomínio')
                                    }
                                    inputValue={companyInputActual}
                                    onInputChange={onInputChangeCompany}
                                    instanceId={3}
                                    {...condominiosMulti.selectProps}
                                />
                            </div>
                        : null }
                        {buscaMulti ? (
                            condominiosMulti.selecionados.length > 0 ? (
                                <div className={styles.adjust_tags_filter}>
                                    {condominiosMulti.selecionados.map((v: any) => (
                                        <button
                                            aria-label={`Botão para remover filtro de empreendimento ${v?.label}`}
                                            title={`Clique para remover filtro de empreendimento ${v?.label}`}
                                            type="button"
                                            className={styles.tags_picker}
                                            onClick={() => condominiosMulti.remover(v?.value)}
                                            key={v?.value}
                                            style={stylesTags2}
                                        >
                                            {v?.label}
                                            <IoCloseSharp
                                                size={16}
                                                color={stylesIconClose}
                                                style={marginIconTag}
                                            />
                                        </button>
                                    ))}
                                </div>
                            ) : null
                        ) : companyActual ? (
                            <div className={styles.adjust_tags_filter}>
                                <button
                                    aria-label={`Botão para remover filtro de empreendimento ${companyActual?.label}`}
                                    title={`Clique para remover filtro de empreendimento ${companyActual?.label}`}
                                    type="button"
                                    className={styles.tags_picker}
                                    onClick={() => {setCompanyActual(0);setPage(1);setAutorizaBusca(true);}}
                                    style={stylesTags2}
                                >
                                    {companyActual?.label}
                                    <IoCloseSharp
                                        size={16}
                                        color={stylesIconClose}
                                        style={marginIconTag}
                                    />
                                </button>
                            </div>
                        ) : null}
                        { listCategory?.length > 0 ?
                            <div className={styles.adjust_select}>
                                <label className={styles.title_select} style={{color: corLetra1}}>
                                    CATEGORIAS
                                </label>
                                <Select
                                    options={listCategory}
                                    className={styles.select}
                                    placeholder="Categorias"
                                    noOptionsMessage={() => 'Categoria não encontrada!'}
                                    styles={colorPicker}
                                    value={categoryActual}
                                    onChange={onChangeCategory}
                                    instanceId={13}
                                    {...categoriasMulti.selectProps}
                                />
                            </div>
                        : null }
                        {buscaMulti ? (
                            categoriasMulti.selecionados.length > 0 ? (
                                <div className={styles.adjust_tags_filter}>
                                    {categoriasMulti.selecionados.map((v: any) => (
                                        <button
                                            aria-label={`Botão para remover filtro da categoria ${v?.label}`}
                                            title={`Clique para remover filtro da categoria ${v?.label}`}
                                            type="button"
                                            className={styles.tags_picker}
                                            onClick={() => categoriasMulti.remover(v?.value)}
                                            key={v?.value}
                                            style={stylesTags2}
                                        >
                                            {v?.label}
                                            <IoCloseSharp
                                                size={16}
                                                color={stylesIconClose}
                                                style={marginIconTag}
                                            />
                                        </button>
                                    ))}
                                </div>
                            ) : null
                        ) : categoryActual ? (
                            <div className={styles.adjust_tags_filter}>
                                <button
                                    aria-label={`Botão para remover filtro da categoria ${categoryActual?.label}`}
                                    title={`Clique para remover filtro da categoria ${categoryActual?.label}`}
                                    type="button"
                                    className={styles.tags_picker}
                                    onClick={() => {
                                        setCategoryActual(null);
                                        setPage(1);
                                        setAutorizaBusca(true);
                                    }}
                                    style={stylesTags2}
                                >
                                    {categoryActual?.label}
                                    <IoCloseSharp
                                        size={16}
                                        color={stylesIconClose}
                                        style={marginIconTag}
                                    />
                                </button>
                            </div>
                        ) : null}
                         { listDatas?.length > 0 && site?.mostrar_data_entrega ?
                            <div className={styles.adjust_select}>
                                <label className={styles.title_select} style={{color: corLetra1}}>
                                    Data de Entrega
                                </label>
                                <Select
                                    options={listDatas}
                                    className={styles.select}
                                    placeholder="Data de entrega"
                                    noOptionsMessage={() => 'Data de entrega não encontrada!'}
                                    styles={colorPicker}
                                    value={dataEntregaActual}
                                    onChange={onChangeDatas}
                                    instanceId={131}
                                />
                            </div>
                        : null }
                        {dataEntregaActual?.length > 0 ? (
                                <div className={styles.adjust_tags_filter}>
                                    {dataEntregaActual?.map((v: any) => {
                                        const removeDtas = () => {
                                            const removeUnique = dataEntregaActual?.filter(
                                                (e: any) => e?.value !== v?.value
                                            );
                                            setDataEntregaActual(removeUnique);
                                            setPage(1);
                                            setAutorizaBusca(true);
                                        };
                                        return (
                                            <button
                                                aria-label={`Botão para remover filtro de data de entrega ${v?.label}`}
                                                title={`Clique para remover filtro de data de entrega ${v?.label}`}
                                                type="button"
                                                className={styles.tags_picker}
                                                onClick={removeDtas}
                                                key={v?.value}
                                                style={stylesTags2}
                                            >
                                                {v?.label}
                                                <IoCloseSharp
                                                    size={16}
                                                    color={stylesIconClose}
                                                    style={marginIconTag}
                                                />
                                            </button>
                                        );
                                    })}
                                </div>
                            ) : null}
                        { listCaract?.length > 0 ?
                            <div className={styles.adjust_select}>
                                <label className={styles.title_select} style={{color: corLetra1}}>
                                    CARACTERÍSTICAS
                                </label>
                                <Select
                                    options={listCaract}
                                    className={styles.select}
                                    placeholder="Características"
                                    noOptionsMessage={() => 'Categoria não encontrada!'}
                                    styles={colorPicker}
                                    value={caractActual}
                                    onChange={onChangeCaracteristicas}
                                    instanceId={0}
                                />
                            </div>
                        : null }
                        {caractActual?.length > 0 ? (
                                <div className={styles.adjust_tags_filter}>
                                    {caractActual?.map((v: any) => {
                                        const removeCaract = () => {
                                            const removeUnique = caractActual?.filter(
                                                (e: any) => e?.value !== v?.value
                                            );
                                            setCaractActual(removeUnique);
                                            setPage(1);
                                            setAutorizaBusca(true);
                                        };
                                        return (
                                            <button
                                                aria-label={`Botão para remover filtro de Característica ${v?.label}`}
                                                title={`Clique para remover filtro do Característica ${v?.label}`}
                                                type="button"
                                                className={styles.tags_picker}
                                                onClick={removeCaract}
                                                key={v?.value}
                                                style={stylesTags2}
                                            >
                                                {v?.label}
                                                <IoCloseSharp
                                                    size={16}
                                                    color={stylesIconClose}
                                                    style={marginIconTag}
                                                />
                                            </button>
                                        );
                                    })}
                                </div>
                            ) : null}
                        {!SEM_FILTRO_AREA_PRIVATIVA_SITES.includes(Number(site?.id)) ? (
                            <div className={styles.adjust_select}>
                                <label className={styles.title_select} style={{color: corLetra1}}>
                                        ÁREA PRIVATIVA
                                </label>
                                <div className={styles.adjust_select_p} style={{width: "100%",minWidth: "100%",maxWidth: "100%",margin: 0}}>
                                    <div className={styles.adjust_select_price1} style={{margin: "0px 2.5% 0px 0px"}}>
                                        <input
                                            className={styles.input}
                                            placeholder={areaAux > 0 ? areaAux[0]+" m²" : "Área Mínima"}
                                            onChange={onChangeAreaMinimo}
                                            inputMode='numeric'
                                            value={areaAux[0] > 0 ? areaAux[0] : ""}
                                            style={legado({ color: corLetra1,border: `2px solid ${corLetra1}` })}
                                        />
                                    </div>
                                    <div className={styles.adjust_select_price1} style={{margin: "0px 0px 0px 2.5%"}}>
                                        <input
                                            className={styles.input}
                                            placeholder={areaAux > 0 ? areaAux[1]+" m²" : "Área Máxima"}
                                            onChange={onChangeAreaMaximo}
                                            inputMode='numeric'
                                            value={areaAux[1] > 0 ? areaAux[1] : ""}
                                            style={legado({ color: corLetra1,border: `2px solid ${corLetra1}` })}
                                        />
                                    </div>
                                </div>
                            </div>
                        ) : null}

                        <div className={styles.adjust_select}>
                            <label className={styles.title_select} style={{color: coresAP || coresLr || coresMt || coresIn || coresNt || coresCp ? corLetra1 : corLetra2}}>
                                CÓDIGOS
                            </label>
                            <input
                                className={styles.input}
                                placeholder="Código"
                                onChange={onChangeCode}
                                value={codeInput}
                                style={legado({ color: corLetra1,border: `2px solid ${corLetra1}` })}
                            />
                        </div>
                        {codeActual ? (
                            <div className={styles.adjust_tags_filter}>
                                <button
                                    aria-label={`Botão para remover filtro por código do imóvel`}
                                    title={`Clique para remover filtro por código do imóvel`}
                                    type="button"
                                    className={styles.tags_picker}
                                    style={stylesTags2}
                                    onClick={() => {setCodeActual('');setPage(1);setAutorizaBusca(true);}}
                                >
                                    {codeActual}
                                    <IoCloseSharp
                                        size={16}
                                        color={stylesIconClose}
                                        style={marginIconTag}
                                    />
                                </button>
                            </div>
                        ) : null}
                        {/* Grade única no desktop: botões das 4 linhas na mesma coluna (CSS .numeros_filtro). */}
                        <div className={styles.numeros_filtro}>
                        {['suites_min', 'garagems_min', 'dormitorios_min', 'banheiros_min'].map(
                            (e) => {
                                const RenderTitle = () => {
                                    if (e === 'suites_min') {
                                        return 'Suítes';
                                    }
                                    if (e === 'garagems_min') {
                                        return 'Vagas';
                                    }
                                    if (e === 'dormitorios_min') {
                                        return 'Quartos';
                                    }
                                    if (e === 'banheiros_min') {
                                        return 'Banheiros';
                                    }
                                };
                                return (
                                    <div className={styles.adjust_flex} key={e}>
                                        <label
                                            className={
                                                styles.title_filter_number
                                            }
                                            style={{color: corLetra1}}
                                        >
                                            {RenderTitle()}
                                        </label>
                                        <div className={styles.flex}>
                                            {['1', '2', '3', '4', '5+'].map(
                                                (v) => {
                                                    const getNumber = Number(
                                                        v.replace('+', '')
                                                    );
                                                    // Atelier: cada botão liga/desliga o seu número (2 e 3 quartos)
                                                    const ativo = qtdMulti
                                                        ? qtdMarcados(filters, e as CampoQtd).includes(getNumber)
                                                        : filters[e] === getNumber;
                                                    const onChangeNumber =
                                                        () => {
                                                            setFilters(qtdMulti ? {
                                                                ...filters,
                                                                ...alternarQtd(filters, e as CampoQtd, getNumber),
                                                            } : {
                                                                ...filters,
                                                                [e]:
                                                                    filters[
                                                                        e
                                                                    ] ===
                                                                    getNumber
                                                                        ? 0
                                                                        : getNumber,
                                                            });
                                                            setPage(1);
                                                            setAutorizaBusca(true);
                                                        };
                                                    return (
                                                        <button
                                                            aria-label={`Botão de filtro de imóveis com ${v} ${RenderTitle()}`}
                                                            title={qtdMulti ? `Clique para marcar ou desmarcar ${v} ${RenderTitle()} (pode marcar mais de um)` : `Clique para buscar imóveis com ${v} ${RenderTitle()}`}
                                                            aria-pressed={qtdMulti ? ativo : undefined}
                                                            type="button"
                                                            style={legado({background: corFundo,color: corLetra1})}
                                                            className={
                                                                ativo
                                                                    ? styles.button_number_active
                                                                    : styles.button_number
                                                            }
                                                            onClick={
                                                                onChangeNumber
                                                            }
                                                            key={v}
                                                        >
                                                            {v}
                                                        </button>
                                                    );
                                                }
                                            )}
                                        </div>
                                    </div>
                                );
                            }
                        )}
                        </div>
                        {activeLargeFilter ? (
                            <button
                                aria-label={`Botão para concluir busca`}
                                title={`Clique para concluir busca`}
                                type="button"
                                onClick={applyFilter}
                                className={styles.button_concluded}
                                style={legado(isColorLight(site?.cor2) ? {background: site?.cor2,color: site?.cor11} : {background: site?.cor2,color: site?.cor13})}
                            >
                                CONCLUÍDO
                            </button>
                        ) : null}
                        {activeLargeFilter ? (
                            <button
                                aria-label={`Botão para fechar busca personalizada`}
                                title={`Clique para fechar busca personalizada`}
                                type="button"
                                onClick={() => setActiveLargeFilter(false)}
                                className={styles.closed_modal}
                            >
                                <IoCloseSharp
                                    size={24}
                                    color={stylesIconClose}
                                    style={marginIconTag}
                                />
                            </button>
                        ) : null}
                    </motion.div>
                ) : null}
            </>
        );
    };
    return (
        <>
            { mapaOn && allPropertiesMapa?.length > 0 && site?.mostrar_mapa ? <Mapa openMapa={1} setOpenMapa={setMapaOn} prop={allPropertiesMapa[0]} properties={allPropertiesMapa} tipo={0}/> : null}
            {size?.width <= 900 && activeLargeFilter ? (
                <div className={styles.container_large_filter} data-nosnippet>
                    {renderFilters()}
                </div>
            ) : null}
            <div className={styles.container_header}>
                {(renderTextFilters && !loading) || naoEncontrou ?
                    renderTextFilters() :
                    <Box sx={{ height: 87, width: '100%' }}>
                        <Skeleton variant="rectangular" width="40%" height="47px" style={{borderRadius: "10px", margin: 5}}/>
                        <Skeleton variant="rectangular" width="20%" height="30px" style={{borderRadius: "10px", margin: 5}}/>
                    </Box>
                }
                {typeValidation ? (
                    <div className={styles.adjust_tags} data-nosnippet>
                        {openFavoritos && favorito?.length > 0 ?
                            <motion.div
                                key="favoritos_limpar"
                                initial={{ opacity: 0, y: 20 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.5, delay: 1.2 }}
                            >
                                <button
                                    aria-label={`Botão para limpar todos os imóveis selecionados como favoritos`}
                                    title={`Clique para limpar os imóveis favoritos`}
                                    onClick={() => limpaFavoritos()} className={styles.tags1} style={stylesTags} type="button">
                                    Limpar Favoritos
                                    <FaTrashAlt
                                        size={16}
                                        color={stylesIconClose1}
                                        style={{margin: '0px 0px 5px 0px'}}
                                    />
                                </button>
                                <button
                                    aria-label={`Botão para abrir página com todos os imóveis`}
                                    title={`Clique para ver Todos os imóveis`}
                                    type="button" onClick={() => {setOpenFavoritos(false);setPage(1);setAutorizaBusca(true);}} style={stylesTags} className={styles.tags1}
                                >
                                    Ver Todos Imóveis
                                </button>
                            </motion.div>
                            : null}
                            {filtroPais && paisActual?.value ? (
                                <motion.div
                                    key="pais_1"
                                    initial={{ opacity: 0, y: 20 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    transition={{ duration: 0.5, delay: 0.5 }}
                                >
                                    <button
                                        aria-label={`Botão para limpar filtro do País ${paisActual?.label}`}
                                        title={`Clique para limpar filtro do País ${paisActual?.label}`}
                                        type="button"
                                        style={stylesTags}
                                        className={styles.tags}
                                        onClick={() => onChangePais(null)}
                                    >
                                        {paisActual?.label}
                                        <IoCloseSharp
                                            size={16}
                                            color={stylesIconClose1}
                                            style={marginIconTag}
                                        />
                                    </button>
                                </motion.div>
                            ) : null}
                            {estadoActual && (site?.id == 2177 || site?.id == 2297 || site?.id == 1942 || site?.id == 2065) ? (
                                <motion.div
                                    key="estado_1"
                                    initial={{ opacity: 0, y: 20 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    transition={{ duration: 0.5, delay: 0.5 }}
                                >
                                    <button
                                        aria-label={`Botão para limpar filtro do Estado ${estadoActual?.label}`}
                                        title={`Clique para limpar filtro do Estado ${estadoActual?.label}`}
                                        type="button"
                                        style={stylesTags}
                                        className={styles.tags}
                                        onClick={() => {
                                            setDistrictActual([]);
                                            setListDistrict([]);
                                            setCityActual(null);
                                            setListCity(cidadesSemEstado());
                                            setEstadoActual(null);
                                            setPage(1);
                                            setAutorizaBusca(true);
                                        }}
                                    >
                                        {estadoActual?.label}
                                        <IoCloseSharp
                                            size={16}
                                            color={stylesIconClose1}
                                            style={marginIconTag}
                                        />
                                    </button>
                                </motion.div>
                            ) : null}
                        {cidadesChipsMulti ? cidadesMulti.cidades.map((v: any) => (
                            <motion.div
                                key={`cidade_${v?.value}`}
                                initial={{ opacity: 0, y: 20 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.5, delay: 0.5 }}
                            >
                                <button
                                    aria-label={`Botão para limpar filtro da cidade ${v?.label}`}
                                    title={`Clique para limpar filtro da cidade ${v?.label}`}
                                    type="button"
                                    style={stylesTags}
                                    className={styles.tags}
                                    onClick={() => removerCidadeMulti(v?.value)}
                                >
                                    {v?.label}
                                    <IoCloseSharp
                                        size={16}
                                        color={stylesIconClose1}
                                        style={marginIconTag}
                                    />
                                </button>
                            </motion.div>
                        )) : cityActual ? (
                            <motion.div
                                key="cidade_1"
                                initial={{ opacity: 0, y: 20 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.5, delay: 0.5 }}
                            >
                                <button
                                    aria-label={`Botão para limpar filtro da cidade ${cityActual?.label}`}
                                    title={`Clique para limpar filtro da cidade ${cityActual?.label}`}
                                    type="button"
                                    style={stylesTags}
                                    className={styles.tags}
                                    onClick={() => {
                                        setCityActual(null);
                                        setDistrictActual([]);
                                        setListDistrict([]);
                                        setPage(1);
                                        setAutorizaBusca(true);
                                    }}
                                >
                                    {cityActual?.label}
                                    <IoCloseSharp
                                        size={16}
                                        color={stylesIconClose1}
                                        style={marginIconTag}
                                    />
                                </button>
                            </motion.div>
                        ) : null}
                        {districtActual?.map((v: any, idx: number) => {
                            const removeDistrict = () => {
                                const removeUnique = districtActual?.filter(
                                    (e: any) => e?.value !== v?.value
                                );
                                setDistrictActual(removeUnique);
                                setPage(1);
                                setAutorizaBusca(true);
                            };
                            return (
                                <motion.div
                                    key={`bairro_${v?.value ?? v?.label ?? idx}`}
                                    initial={{ opacity: 0, y: 20 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    transition={{ duration: 0.5, delay: 0.6 }}
                                >
                                    <button
                                        aria-label={`Botão para limpar filtro do bairro ${v?.label}`}
                                        title={`Clique para limpar filtro do bairro ${v?.label}`}
                                        type="button"
                                        className={styles.tags}
                                        onClick={removeDistrict}
                                        style={stylesTags}
                                    >
                                        {v?.label}
                                        <IoCloseSharp
                                            size={16}
                                            color={stylesIconClose1}
                                            style={marginIconTag}
                                        />
                                    </button>
                                </motion.div>
                            );
                        })}
                        {typeActual?.map((v: any, idx: number) => {
                            const removeType = () => {
                                const removeUnique = typeActual?.filter(
                                    (e: any) => e?.value !== v?.value
                                );
                                setTypeActual(removeUnique);
                                setPage(1);
                                setAutorizaBusca(true);
                            };
                            return (
                                <motion.div
                                    initial={{ opacity: 0, y: 20 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    key={`tipo_${v?.value ?? v?.label ?? idx}`}
                                    transition={{ duration: 0.5, delay: 0.7 }}
                                >
                                    <button
                                        aria-label={`Botão para limpar filtro do tipo ${v?.label}`}
                                        title={`Clique para limpar filtro dos tipo ${v?.label}`}
                                        type="button"
                                        className={styles.tags}
                                        onClick={removeType}
                                        style={stylesTags}
                                    >
                                        {v?.label}
                                        <IoCloseSharp
                                            size={16}
                                            color={stylesIconClose1}
                                            style={marginIconTag}
                                        />
                                    </button>
                                </motion.div>
                            );
                        })}
                        {caractActual?.map((v: any, idx: number) => {
                            const removecar = () => {
                                const removeUnique = caractActual?.filter(
                                    (e: any) => e?.value !== v?.value
                                );
                                setCaractActual(removeUnique);
                                setPage(1);
                                setAutorizaBusca(true);
                            };
                            return (
                                <motion.div
                                    initial={{ opacity: 0, y: 20 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    key={`caract_${v?.value ?? v?.label ?? idx}`}
                                    transition={{ duration: 0.5, delay: 0.7 }}
                                >
                                    <button
                                        aria-label={`Botão para limpar filtro da característica ${v?.label}`}
                                        title={`Clique para limpar filtro da característica ${v?.label}`}
                                        type="button"
                                        className={styles.tags}
                                        onClick={removecar}
                                        style={stylesTags}
                                    >
                                        {v?.label}
                                        <IoCloseSharp
                                            size={16}
                                            color={stylesIconClose1}
                                            style={marginIconTag}
                                        />
                                    </button>
                                </motion.div>
                            );
                        })}
                        {buscaMulti ? condominiosMulti.selecionados.map((v: any) => (
                            <motion.div
                                key={`empreendimento_${v?.value}`}
                                initial={{ opacity: 0, y: 20 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.5, delay: 0.8 }}
                            >
                                <button
                                    aria-label={`Botão para limpar filtro do empreendimento ${v?.label}`}
                                    title={`Clique para limpar filtro do empreendimento ${v?.label}`}
                                    type="button"
                                    className={styles.tags}
                                    onClick={() => condominiosMulti.remover(v?.value)}
                                    style={stylesTags}
                                >
                                    {v?.label}
                                    <IoCloseSharp
                                        size={16}
                                        color={stylesIconClose1}
                                        style={marginIconTag}
                                    />
                                </button>
                            </motion.div>
                        )) : companyActual ? (
                            <motion.div
                                key="empreendimento_1"
                                initial={{ opacity: 0, y: 20 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.5, delay: 0.8 }}
                            >
                                <button
                                    aria-label={`Botão para limpar filtro do empreendimento ${companyActual?.label}`}
                                    title={`Clique para limpar filtro do empreendimento ${companyActual?.label}`}
                                    type="button"
                                    className={styles.tags}
                                    onClick={() => {setCompanyActual(0);setPage(1);setAutorizaBusca(true);}}
                                    style={stylesTags}
                                >
                                    {companyActual?.label}
                                    <IoCloseSharp
                                        size={16}
                                        color={stylesIconClose1}
                                        style={marginIconTag}
                                    />
                                </button>
                            </motion.div>
                        ) : null}
                        {buscaMulti ? categoriasMulti.selecionados.map((v: any) => (
                            <motion.div
                                key={`categoria_${v?.value}`}
                                initial={{ opacity: 0, y: 20 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.5, delay: 0.9 }}
                            >
                                <button
                                    aria-label={`Botão para remover filtro da categoria ${v?.label}`}
                                    title={`Clique para remover filtro da categoria ${v?.label}`}
                                    type="button"
                                    className={styles.tags}
                                    onClick={() => categoriasMulti.remover(v?.value)}
                                    style={stylesTags}
                                >
                                    {v?.label}
                                    <IoCloseSharp
                                        size={16}
                                        color={stylesIconClose1}
                                        style={marginIconTag}
                                    />
                                </button>
                            </motion.div>
                        )) : categoryActual ? (
                            <motion.div
                                key="categoria_1"
                                initial={{ opacity: 0, y: 20 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.5, delay: 0.9 }}
                            >
                                <button
                                    aria-label={`Botão para remover filtro da categoria ${categoryActual?.label}`}
                                    title={`Clique para remover filtro da categoria ${categoryActual?.label}`}
                                    type="button"
                                    className={styles.tags}
                                    onClick={() => {
                                        setCategoryActual(null);
                                        setPage(1);
                                        setAutorizaBusca(true);
                                    }}
                                    style={stylesTags}
                                >
                                    {categoryActual?.label}
                                    <IoCloseSharp
                                        size={16}
                                        color={stylesIconClose1}
                                        style={marginIconTag}
                                    />
                                </button>
                            </motion.div>
                        ) : null}
                        {dataEntregaActual?.map((v: any, idx: number) => {
                            const removdt = () => {
                                const removeUnique = dataEntregaActual?.filter(
                                    (e: any) => e?.value !== v?.value
                                );
                                setDataEntregaActual(removeUnique);
                                setPage(1);
                                setAutorizaBusca(true);
                            };
                            return (
                                <motion.div
                                    initial={{ opacity: 0, y: 20 }}
                                    key={`data_${v?.value ?? v?.label ?? idx}`}
                                    animate={{ opacity: 1, y: 0 }}
                                    transition={{ duration: 0.5, delay: 0.7 }}
                                >
                                    <button
                                        aria-label={`Botão para remover filtro de data de entrega ${dataEntregaActual?.label}`}
                                        title={`Clique para remover filtro de data de entrega ${dataEntregaActual?.label}`}
                                        type="button"
                                        className={styles.tags}
                                        onClick={removdt}
                                        style={stylesTags}
                                    >
                                        {v?.label}
                                        <IoCloseSharp
                                            size={16}
                                            color={stylesIconClose1}
                                            style={marginIconTag}
                                        />
                                    </button>
                                </motion.div>
                            );
                        })}
                        {codeActual ? (
                            <motion.div
                                key="codigo_1"
                                initial={{ opacity: 0, y: 20 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.5, delay: 1 }}
                            >
                                <button
                                    aria-label={`Botão para limpar filtro por código do imóvel: ${codeActual}`}
                                    title={`Clique para limpar filtro por código do imóvel: ${codeActual}`}
                                    type="button"
                                    className={styles.tags}
                                    style={stylesTags}
                                    onClick={() =>
                                        {setCodeActual('');setPage(1);setAutorizaBusca(true);}
                                    }
                                >
                                    {codeActual}
                                    <IoCloseSharp
                                        size={16}
                                        color={stylesIconClose1}
                                        style={marginIconTag}
                                    />
                                </button>
                            </motion.div>
                        ) : null}
                        {/* BUSCA POR IA: "2+ suítes" é MÍNIMO e não tem botão no filtro lateral
                            (lá os números são exatos) — o chip mostra o filtro e deixa tirar. */}
                        {onRemoverMinimoBuscaIa && minimosBuscaIa?.map((m) => (
                            <motion.div
                                key={`minimo_ia_${m.campo}`}
                                initial={{ opacity: 0, y: 20 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.5, delay: 1 }}
                            >
                                <button
                                    aria-label={`Botão para limpar o filtro ${m.rotulo}`}
                                    title={`Clique para limpar o filtro ${m.rotulo}`}
                                    type="button"
                                    className={styles.tags}
                                    style={stylesTags}
                                    onClick={() => {
                                        onRemoverMinimoBuscaIa(m.campo);
                                        setPage(1);
                                        setAutorizaBusca(true);
                                    }}
                                >
                                    {m.rotulo}
                                    <IoCloseSharp
                                        size={16}
                                        color={stylesIconClose1}
                                        style={marginIconTag}
                                    />
                                </button>
                            </motion.div>
                        ))}
                        {/* #1117: na lista de FAVORITOS a transação não filtra mais nada (a seleção
                            do visitante é o recorte), então o chip "Venda/Aluguel" só mentiria —
                            aparecia "Venda" numa lista de galpões de locação. Sair dos favoritos
                            continua a um clique, pelo botão "Ver Todos Imóveis". */}
                        {!type || site?.transacoes?.length <= 1 || (openFavoritos && favorito?.length > 0) ? null : (
                            <motion.div
                                key="transacao_1"
                                initial={{ opacity: 0, y: 20 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.5, delay: 1.1 }}
                            >
                                <button
                                    aria-label={`Botão para limpar de transação`}
                                    title={`Clique para limpar filtro de transação`}
                                    type="button"
                                    className={styles.tags}
                                    onClick={onChangeType}
                                    style={stylesTags}
                                >
                                    {type === 'sale' ? 'Venda' : ''}
                                    {type === 'rent' ? 'Aluguel' : ''}
                                    {type === 'temporada' ? 'Temporada' : ''}
                                    <IoCloseSharp
                                        size={16}
                                        color={stylesIconClose1}
                                        style={marginIconTag}
                                    />
                                </button>
                            </motion.div>
                        )}
                    </div>
                ) : null}
            </div>
            <div className={styles.container_select} data-nosnippet>
                {size?.width <= 900 && typeValidation ? (
                    <button
                        aria-label={`Botão para abrir filtros personalizados`}
                        title={`Clique para abrir filtros personalizados`}
                        type="button"
                        className={styles.mapa_button}
                        style={legado({borderColor: corLetra2,color: corLetra2})}
                        onClick={openFilter}
                    >
                        <IoFilterOutline
                            size={24}
                            color={corLetra2}
                            style={{ marginRight: 5 }}
                        />
                        Filtrar
                    </button>
                ) : null}
                { !isMobile && size?.width > 1150 && typeValidation ?
                    <button
                        aria-label={`Botão para alterar apresentação dos cards de imóveis`}
                        title={`Clique para alterar apresentação dos cards de imóveis`}
                        type="button" onClick={() => positionCard ? setPositionCard(0) : setPositionCard(1)} className={horizonte || coresAP || coresLr || coresMt || coresIn || coresNt || coresCp ? styles.alternar_layout : undefined} style={legado({background: "none",margin: "0px 13px 6px 5px",border: "none",padding: "0px"})}>
                        { isHorizontalCardLayout ?
                            <FaTh
                                size={25}
                                color={corLetra2}
                                style={{margin: '0px', cursor: 'pointer'}}
                            />
                        :
                            <FaThList
                                size={25}
                                color={corLetra2}
                                style={{margin: '0px',  cursor: 'pointer'}}
                            />
                        }
                    </button>
                : null }
                { allPropertiesMapa?.length > 0 && site?.mostrar_mapa && typeValidation ?
                    <button
                        aria-label={`Botão para ver imóveis no Mapa`}
                        title={`Clique para ver imóveis no Mapa`}
                        style={legado({borderColor: corLetra2,color: corLetra2})}
                        type="button" onClick={() => setMapaOn(1)} className={styles.mapa_button}>
                        <HiMapPin
                            size={15}
                            color={corLetra2}
                            style={{margin: '0px 5px 0px 0px'}}
                        />
                        Mapa
                    </button> : null }
                {typeValidation && site?.id != '2049' ? (
                    <div
                        className={`${styles.adjust_select_order} ${orderMenuInteractionLocked ? styles.adjust_select_order_open : ''}`}
                        onClick={(e) => e.stopPropagation()}
                        onMouseDown={(e) => e.stopPropagation()}
                        onPointerDown={(e) => e.stopPropagation()}
                    >
                        <Select
                            ref={orderSelectRef}
                            options={[
                                // busca por IA com "perto": "Mais próximos de {lugar}" (1ª opção)
                                ...(opcaoOrdemBuscaIa ? [opcaoOrdemBuscaIa] : []),
                                ...(ordemSemMaisRecentes(site) ? [] : [{
                                    label: 'Mais Recentes',
                                    value: 'desc-inclusao',
                                }]),
                                {
                                    label: 'Mais Antigos',
                                    value: 'asc-inclusao',
                                },
                                {
                                    label: 'Maior Valor',
                                    value: 'desc-valor',
                                },
                                {
                                    label: 'Menor Valor',
                                    value: 'asc-valor',
                                },
                                {
                                    label: 'Mais Visitados',
                                    value: 'desc-visualizacao',
                                },
                                {
                                    label: 'Menos Visitados',
                                    value: 'asc-visualizacao',
                                },
                                {
                                    label: 'Exclusivos',
                                    value: 'asc-exclusivos',
                                },
                            ]}
                            className={styles.select_order}
                            placeholder="Ordenar"
                            styles={orderSelectStyles}
                            value={orderActual}
                            onChange={onChangeOrder}
                            onMenuOpen={handleOrderMenuOpen}
                            onMenuClose={handleOrderMenuClose}
                            menuIsOpen={!activeLargeFilter && orderMenuOpen}
                            menuPortalTarget={activeLargeFilter ? undefined : orderSelectPortalTarget}
                            menuPosition="fixed"
                            menuShouldBlockScroll={true}
                            instanceId={4}
                        />
                    </div>
                ) : null}
            </div>
            {faixaBuscaIa}
            {site?.exibir_empreendimento && typeValidation && !loading && !empreendimentoDetalheLoading && empreendimentoResumo ? (
                <Link
                    href={empreendimentoResumo.href}
                    className={styles.empreendimentoSpotlight}
                    aria-label={`Ver detalhes do empreendimento ${empreendimentoResumo.nome}`}
                >
                    <div className={styles.empreendimentoSpotlightMedia}>
                        <Image
                            src={empreendimentoResumo.foto}
                            alt={empreendimentoResumo.nome}
                            fill
                            sizes="(max-width: 900px) 100vw, 360px"
                            className={styles.empreendimentoSpotlightImage}
                        />
                        <span className={styles.empreendimentoSpotlightBadge}>
                            {empreendimentoResumo.categoria || 'Empreendimento'}
                        </span>
                    </div>
                    <div className={styles.empreendimentoSpotlightContent}>
                        <h2 className={styles.empreendimentoSpotlightTitle}>{empreendimentoResumo.nome}</h2>
                        {empreendimentoResumo.localizacao ? (
                            <p className={styles.empreendimentoSpotlightLocation}>
                                <HiMapPin size={16} />
                                <span>{empreendimentoResumo.localizacao}</span>
                            </p>
                        ) : null}
                        {empreendimentoResumo?.caracteristicas?.length > 0 ? (
                            <div className={styles.empreendimentoSpotlightFeatureList}>
                                {empreendimentoResumo.caracteristicas.map((item: string) => (
                                    <span key={`${empreendimentoResumo.nome}-${item}`} className={styles.empreendimentoSpotlightFeatureTag}>
                                        {item}
                                    </span>
                                ))}
                            </div>
                        ) : null}
                        {empreendimentoResumo?.highlights?.length > 0 ? (
                            <div className={styles.empreendimentoSpotlightHighlights}>
                                {empreendimentoResumo.highlights.map((item: any) => (
                                    <div key={item.key} className={styles.empreendimentoSpotlightHighlightItem}>
                                        {item.icon === 'dormitorios' ? (
                                            <FaBed className={styles.empreendimentoSpotlightHighlightIcon} />
                                        ) : null}
                                        {item.icon === 'area' ? (
                                            <FaRulerCombined className={styles.empreendimentoSpotlightHighlightIcon} />
                                        ) : null}
                                        {item.icon === 'banheiros' ? (
                                            <FaBath className={styles.empreendimentoSpotlightHighlightIcon} />
                                        ) : null}
                                        {item.icon === 'vagas' ? (
                                            <FaCar className={styles.empreendimentoSpotlightHighlightIcon} />
                                        ) : null}
                                        <span>{item.label}</span>
                                    </div>
                                ))}
                            </div>
                        ) : null}
                        <div className={styles.empreendimentoSpotlightStats}>
                            <div className={styles.empreendimentoSpotlightStat}>
                                <span className={styles.empreendimentoSpotlightLabel}>Faixa de preco</span>
                                <strong>{precoVivo && empreendimentoResumo.faixaPreco ? faixaPrecoVivo(empreendimentoResumo) : (empreendimentoResumo.faixaPreco || 'Consulte')}</strong>
                            </div>
                            <div className={styles.empreendimentoSpotlightStat}>
                                <span className={styles.empreendimentoSpotlightLabel}>Area privativa</span>
                                <strong>{empreendimentoResumo.faixaArea || 'Consulte'}</strong>
                            </div>
                            <div className={styles.empreendimentoSpotlightStat}>
                                <span className={styles.empreendimentoSpotlightLabel}>Situacao</span>
                                <strong>{empreendimentoResumo.situacao || 'Disponivel'}</strong>
                            </div>
                        </div>
                    </div>
                </Link>
            ) : null}
            <div className={styles.container_all_list}>
            <div className={styles.geral}>
            {(agenciador && site?.exibir_agenciador && managerActual?.url_foto && typeValidation) ? (
                <>
                    <IconButton aria-label="delete" className={styles.button_delete} onClick={() => {setAgenciador(0);setPage(1);setAutorizaBusca(true);}}>
                        <CloseIcon/>
                    </IconButton>
                    <div key={managerActual?.id} className={styles.info_manager}>
                        {status === 'valid' ? (
                            <Image style={legado({border:"1px solid" +site?.cor2})} width={215} height={215} src={managerActual?.url_foto.replace("_g","_m")} alt="Foto Corretor" className={styles.img}></Image>
                        ) : null}
                        <div className={styles.info}>
                            <label className={styles.name}>{managerActual?.nome}</label>
                            {site?.id != '2091' ?
                                <label className={styles.manager}>{managerActual?.funcao?.nome}</label>
                            : null}
                            <div>
                                {managerActual?.instagram ? (
                                    <a
                                        href={managerActual?.instagram}
                                        target="_blank"
                                        rel="noreferrer"
                                        className={styles.network}
                                    >
                                        <svg viewBox="0 0 48 48" height={28} width={28}>
                                            <path d="M 16.5 5 C 10.16639 5 5 10.16639 5 16.5 L 5 31.5 C 5 37.832757 10.166209 43 16.5 43 L 31.5 43 C 37.832938 43 43 37.832938 43 31.5 L 43 16.5 C 43 10.166209 37.832757 5 31.5 5 L 16.5 5 z M 16.5 8 L 31.5 8 C 36.211243 8 40 11.787791 40 16.5 L 40 31.5 C 40 36.211062 36.211062 40 31.5 40 L 16.5 40 C 11.787791 40 8 36.211243 8 31.5 L 8 16.5 C 8 11.78761 11.78761 8 16.5 8 z M 34 12 C 32.895 12 32 12.895 32 14 C 32 15.105 32.895 16 34 16 C 35.105 16 36 15.105 36 14 C 36 12.895 35.105 12 34 12 z M 24 14 C 18.495178 14 14 18.495178 14 24 C 14 29.504822 18.495178 34 24 34 C 29.504822 34 34 29.504822 34 24 C 34 18.495178 29.504822 14 24 14 z M 24 17 C 27.883178 17 31 20.116822 31 24 C 31 27.883178 27.883178 31 24 31 C 20.116822 31 17 27.883178 17 24 C 17 20.116822 20.116822 17 24 17 z"/>
                                        </svg>
                                    </a>
                                ) : null}
                                {managerActual?.telefone ? (
                                    <a
                                        href={whatsParaImobiliaria(managerActual?.internacional ? `https://api.whatsapp.com/send?phone=${managerActual?.telefone?.replace(
                                                /\D/g,
                                                ''
                                            )}&text=${site?.texto_botao_whats ? site?.texto_botao_whats : "Olá, estou visitando o site da "+site?.titulo+", gostaria de um atendimento personalizado. Pode me ajudar?"} ` : `https://api.whatsapp.com/send?phone=55${managerActual?.telefone?.replace(
                                                /\D/g,
                                                ''
                                            )}&text=${site?.texto_botao_whats ? site?.texto_botao_whats : "Olá, estou visitando o site da "+site?.titulo+", gostaria de um atendimento personalizado. Pode me ajudar?"} `, site, managerActual, 'L')}
                                        onClick={async (e) => {
                                            e.preventDefault(); // Evita o redirecionamento automático

                                            trackLead(site, null); // 🔥 Registra o evento Lead

                                            // 🔹 Garante que o evento seja enviado antes de abrir o WhatsApp
                                            setTimeout(() => {
                                            window.open(
                                                whatsParaImobiliaria(managerActual?.internacional ? `https://api.whatsapp.com/send?phone=${managerActual?.telefone?.replace(
                                                    /\D/g,
                                                    ''
                                                )}&text=${site?.texto_botao_whats ? site?.texto_botao_whats : "Olá, estou visitando o site da "+site?.titulo+", gostaria de um atendimento personalizado. Pode me ajudar?"} ` : `https://api.whatsapp.com/send?phone=55${managerActual?.telefone?.replace(
                                                    /\D/g,
                                                    ''
                                                )}&text=${site?.texto_botao_whats ? site?.texto_botao_whats : "Olá, estou visitando o site da "+site?.titulo+", gostaria de um atendimento personalizado. Pode me ajudar?"} `, site, managerActual, 'L'),
                                                "_blank"
                                            );
                                            }, 300); // Pequeno atraso de 300ms para o evento ser registrado
                                        }}
                                        rel="noreferrer"
                                        className={styles.network}
                                    >
                                        <svg viewBox="0 0 32 32" height="30px" width="30px" fill="#34af23">
                                            <path d="M 24.503906 7.503906 C 22.246094 5.246094 19.246094 4 16.050781 4 C 9.464844 4 4.101562 9.359375 4.101562 15.945312 C 4.097656 18.050781 4.648438 20.105469 5.695312 21.917969 L 4 28.109375 L 10.335938 26.445312 C 12.078125 27.398438 14.046875 27.898438 16.046875 27.902344 L 16.050781 27.902344 C 22.636719 27.902344 27.996094 22.542969 28 15.953125 C 28 12.761719 26.757812 9.761719 24.503906 7.503906 Z M 16.050781 25.882812 L 16.046875 25.882812 C 14.265625 25.882812 12.515625 25.402344 10.992188 24.5 L 10.628906 24.285156 L 6.867188 25.269531 L 7.871094 21.605469 L 7.636719 21.230469 C 6.640625 19.648438 6.117188 17.820312 6.117188 15.945312 C 6.117188 10.472656 10.574219 6.019531 16.054688 6.019531 C 18.707031 6.019531 21.199219 7.054688 23.074219 8.929688 C 24.949219 10.808594 25.980469 13.300781 25.980469 15.953125 C 25.980469 21.429688 21.523438 25.882812 16.050781 25.882812 Z M 21.496094 18.445312 C 21.199219 18.296875 19.730469 17.574219 19.457031 17.476562 C 19.183594 17.375 18.984375 17.328125 18.785156 17.625 C 18.585938 17.925781 18.015625 18.597656 17.839844 18.796875 C 17.667969 18.992188 17.492188 19.019531 17.195312 18.871094 C 16.894531 18.722656 15.933594 18.40625 14.792969 17.386719 C 13.90625 16.597656 13.304688 15.617188 13.132812 15.320312 C 12.957031 15.019531 13.113281 14.859375 13.261719 14.710938 C 13.398438 14.578125 13.5625 14.363281 13.710938 14.1875 C 13.859375 14.015625 13.910156 13.890625 14.011719 13.691406 C 14.109375 13.492188 14.058594 13.316406 13.984375 13.167969 C 13.910156 13.019531 13.3125 11.546875 13.0625 10.949219 C 12.820312 10.367188 12.574219 10.449219 12.390625 10.4375 C 12.21875 10.429688 12.019531 10.429688 11.820312 10.429688 C 11.621094 10.429688 11.296875 10.503906 11.023438 10.804688 C 10.75 11.101562 9.980469 11.824219 9.980469 13.292969 C 9.980469 14.761719 11.050781 16.183594 11.199219 16.382812 C 11.347656 16.578125 13.304688 19.59375 16.300781 20.886719 C 17.011719 21.195312 17.566406 21.378906 18 21.515625 C 18.714844 21.742188 19.367188 21.710938 19.882812 21.636719 C 20.457031 21.550781 21.648438 20.914062 21.898438 20.214844 C 22.144531 19.519531 22.144531 18.921875 22.070312 18.796875 C 21.996094 18.671875 21.796875 18.597656 21.496094 18.445312 Z M 21.496094 18.445312 "/>
                                        </svg>
                                    </a>
                                ) : null}
                                {managerActual?.facebook ? (
                                    <a
                                        href={managerActual?.facebook}
                                        target="_blank"
                                        rel="noreferrer"
                                        className={styles.network}
                                    >
                                        <svg viewBox="0 0 32 32" height="30px" width="30px">
                                            <path d="M 16 4 C 9.3844276 4 4 9.3844276 4 16 C 4 22.615572 9.3844276 28 16 28 C 22.615572 28 28 22.615572 28 16 C 28 9.3844276 22.615572 4 16 4 z M 16 6 C 21.534692 6 26 10.465308 26 16 C 26 21.027386 22.311682 25.161277 17.488281 25.878906 L 17.488281 18.916016 L 20.335938 18.916016 L 20.783203 16.023438 L 17.488281 16.023438 L 17.488281 14.443359 C 17.488281 13.242359 17.882859 12.175781 19.005859 12.175781 L 20.810547 12.175781 L 20.810547 9.6523438 C 20.493547 9.6093438 19.822688 9.515625 18.554688 9.515625 C 15.906688 9.515625 14.355469 10.913609 14.355469 14.099609 L 14.355469 16.023438 L 11.632812 16.023438 L 11.632812 18.916016 L 14.355469 18.916016 L 14.355469 25.853516 C 9.6088556 25.070647 6 20.973047 6 16 C 6 10.465308 10.465308 6 16 6 z"/>
                                        </svg>
                                    </a>
                                ) : null}
                                {managerActual?.linkedin ? (
                                    <a
                                        href={managerActual?.linkedin}
                                        target="_blank"
                                        rel="noreferrer"
                                        className={styles.network}
                                    >
                                        <Image
                                            src={IconLinkedin}
                                            height={30}
                                            width={30}
                                            objectFit="contain"
                                            alt="Icone Linkedin"
                                        />
                                    </a>
                                ) : null}
                            </div>
                            {managerActual?.creci ? (
                                <label
                                    className={styles.creci}
                                >{`Creci: ${managerActual?.creci}`}</label>
                            ) : null}
                        </div>
                    </div>
                </>
            ) : null}
                {size?.width > 900 ? renderFilters() : null}
                </div>
                {loading === false && allProperties?.length > 0 ? (
                    <div
                        className={`${typeValidation ? styles.container : styles.container_company} ${orderMenuInteractionLocked ? styles.cards_interaction_locked : ''}${cardHorizonte && !isHorizontalCardLayout ? ` ${styles.grade_hz}` : ''}${cardModeloAP && !isHorizontalCardLayout ? ` ${styles.grade_ap}` : ''}${cardLarissa && !isHorizontalCardLayout ? ` ${styles.grade_lr}` : ''}${cardMetropole && !isHorizontalCardLayout ? ` ${styles.grade_mt}` : ''}${cardIn && !isHorizontalCardLayout ? ` ${styles.grade_in}` : ''}${cardNt && !isHorizontalCardLayout ? ` ${styles.grade_nt}` : ''}${cardCp && !isHorizontalCardLayout ? ` ${styles.grade_cp}` : ''}`}
                        data-grade-modelo={cardModeloAP && !isHorizontalCardLayout ? coresAP?.modelo : cardLarissa && !isHorizontalCardLayout ? 'larissa' : cardMetropole && !isHorizontalCardLayout ? 'metropole' : cardIn && !isHorizontalCardLayout ? 'internacional' : cardNt && !isHorizontalCardLayout ? 'norte' : cardCp && !isHorizontalCardLayout ? 'campo' : undefined}
                    >
                        { isHorizontalCardLayout ?
                            allProperties?.map((v: any, i: number) => (
                                <motion.div
                                    key={v?.id}
                                    initial={motionBase.initial as any}
                                    animate={motionBase.animate as any}
                                    transition={disableEntryMotion ? { duration: 0 } : { duration: 0.5, delay: i * 0.2 }}
                                    className={styles.card_horizontal1}
                                >
                                    <CardApartamentHorizontal
                                        slide={v}
                                        i={i}
                                        key={v?.id}
                                        site={site}
                                        stylesCard={styles.card_horizontal}
                                        allViewProperties={allViewProperties}
                                        favorito={favorito}
                                        setFavorito={setFavorito}
                                    />
                                </motion.div>
                            ))
                        : cardHorizonte ?
                            <GradeHorizonte
                                imoveis={allProperties}
                                site={site}
                                codsite={codsite2}
                                favorito={favorito}
                                className={styles.card_hz}
                                semEntrada={disableEntryMotion}
                            />
                        : cardModeloAP && coresAP ?
                            <GradeModeloAP
                                modelo={coresAP.modelo}
                                imoveis={allProperties}
                                site={site}
                                codsite={codsite2}
                                favorito={favorito}
                                className={styles.card_ap}
                                semEntrada={disableEntryMotion}
                            />
                        : cardLarissa ?
                            <GradeLarissa
                                imoveis={allProperties}
                                site={site}
                                codsite={codsite2}
                                favorito={favorito}
                                className={styles.card_lr}
                                semEntrada={disableEntryMotion}
                            />
                        : cardMetropole ?
                            <GradeMetropole
                                imoveis={allProperties}
                                site={site}
                                codsite={codsite2}
                                favorito={favorito}
                                className={styles.card_mt}
                                semEntrada={disableEntryMotion}
                            />
                        : cardIn ?
                            <GradeInternacional
                                imoveis={allProperties}
                                site={site}
                                codsite={codsite2}
                                favorito={favorito}
                                className={styles.card_in}
                                semEntrada={disableEntryMotion}
                            />
                        : cardNt ?
                            <GradeNorte
                                imoveis={allProperties}
                                site={site}
                                codsite={codsite2}
                                favorito={favorito}
                                className={styles.card_nt}
                                semEntrada={disableEntryMotion}
                            />
                        : cardCp ?
                            <GradeCampo
                                imoveis={allProperties}
                                site={site}
                                codsite={codsite2}
                                favorito={favorito}
                                className={styles.card_cp}
                                semEntrada={disableEntryMotion}
                            />
                        :
                            allProperties?.map((v: any, i: number) => (
                                <motion.div
                                    key={v?.id}
                                    initial={motionBase.initial as any}
                                    animate={motionBase.animate as any}
                                    transition={disableEntryMotion ? { duration: 0 } : { duration: 0.5, delay: i * 0.2 }}
                                    className={site?.modelo_card > 1 ? styles.card11 : typeValidation
                                        ? styles.card1
                                        : styles.card_company1}
                                >
                                    {site?.modelo_card == 9 ?
                                    <CardAtelierLista
                                        slide={v}
                                        site={site}
                                        favorito={favorito}
                                        codsite={codsite2}
                                    /> : site?.modelo_card == 4 ?
                                    <CardApartamentImersivo
                                        slide={v}
                                        i={i}
                                        key={v?.id}
                                        site={site}
                                        allViewProperties={allViewProperties}
                                        favorito={favorito}
                                        codsite={codsite2}
                                    /> : site?.modelo_card == 2 ?
                                    <CardApartament1
                                        slide={v}
                                        i={i}
                                        key={v?.id}
                                        site={site}
                                        stylesCard={styles.card3}
                                        allViewProperties={allViewProperties}
                                        favorito={favorito}
                                        codsite={codsite2}
                                    /> : site?.modelo_card == 1 ?
                                    <CardApartament
                                        slide={v}
                                        i={i}
                                        key={v?.id}
                                        site={site}
                                        stylesCard={styles.card2}
                                        allViewProperties={allViewProperties}
                                        favorito={favorito}
                                        codsite={codsite2}
                                    /> :
                                    <CardApartament3
                                        slide={v}
                                        i={i}
                                        key={v?.id}
                                        site={site}
                                        stylesCard={styles.card2}
                                        allViewProperties={allViewProperties}
                                        favorito={favorito}
                                        codsite={codsite2}
                                    />
                                    }
                                </motion.div>
                            ))
                        }
                    </div>
                ) : null}
                {naoEncontrou ? (
                    <div className={styles.empty_state}>
                        <div
                            className={styles.empty_card}
                            style={legado({ background: hexToRgba(site?.cor2, 0.06), borderColor: hexToRgba(site?.cor2, 0.22) })}
                        >
                            <div className={styles.empty_icon} style={legado({ background: hexToRgba(site?.cor2, 0.12), color: site?.cor2 })}>
                                {openFavoritos ? (
                                    <svg width="38" height="38" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                                        <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.29 1.51 4.04 3 5.5l7 7Z" />
                                    </svg>
                                ) : (
                                    <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                                        <circle cx="11" cy="11" r="7" />
                                        <line x1="21" y1="21" x2="16.65" y2="16.65" />
                                        <line x1="8" y1="11" x2="14" y2="11" />
                                    </svg>
                                )}
                            </div>
                            <p className={styles.empty_title} style={{ color: corLetra2 }}>
                                {openFavoritos ? 'Nenhum imóvel favorito encontrado' : 'Nenhum imóvel encontrado'}
                            </p>
                            <p className={styles.empty_subtitle} style={{ color: hexToRgba(corLetra2, 0.72) }}>
                                {openFavoritos
                                    ? 'Você ainda não favoritou imóveis com esse filtro. Veja todos os nossos imóveis disponíveis.'
                                    : 'Não encontramos imóveis para os filtros selecionados. Tente ajustar a busca ou veja todos os nossos imóveis.'}
                            </p>
                            <button
                                aria-label="Botão para ver todos os imóveis"
                                title="Clique para ver todos os imóveis"
                                type="button"
                                onClick={() => {
                                    setPage(1);
                                    if (openFavoritos) { setOpenFavoritos(false); setAutorizaBusca(true); }
                                    else if (zeraFiltros) { zeraFiltros(); }
                                    else { setAutorizaBusca(true); }
                                }}
                                className={styles.ver_todos_btn}
                                style={legado({
                                    backgroundColor: site?.cor2,
                                    color: isColorLight(site?.cor2) ? site?.cor11 : site?.cor13,
                                })}
                            >
                                Ver todos os imóveis
                            </button>
                        </div>

                        {!openFavoritos && Array.isArray(emptyStateSuggestions) && emptyStateSuggestions.length > 0 ? (
                            <div className={styles.empty_suggestions}>
                                <p className={styles.empty_sugg_title} style={{ color: corLetra2 }}>
                                    Veja outros imóveis que podem te interessar
                                </p>
                                <div className={`${styles.empty_sugg_grid}${cardHorizonte ? ` ${styles.grade_hz}` : ''}${cardModeloAP ? ` ${styles.grade_ap}` : ''}${cardLarissa ? ` ${styles.grade_lr}` : ''}${cardMetropole ? ` ${styles.grade_mt}` : ''}${cardIn ? ` ${styles.grade_in}` : ''}${cardNt ? ` ${styles.grade_nt}` : ''}${cardCp ? ` ${styles.grade_cp}` : ''}`} data-grade-modelo={cardModeloAP ? coresAP?.modelo : cardLarissa ? 'larissa' : cardMetropole ? 'metropole' : cardIn ? 'internacional' : cardNt ? 'norte' : cardCp ? 'campo' : undefined}>
                                    {cardHorizonte ? (
                                        <GradeHorizonte imoveis={emptyStateSuggestions} site={site} codsite={codsite2} favorito={favorito} className={styles.card_hz} />
                                    ) : cardModeloAP && coresAP ? (
                                        <GradeModeloAP modelo={coresAP.modelo} imoveis={emptyStateSuggestions} site={site} codsite={codsite2} favorito={favorito} className={styles.card_ap} />
                                    ) : cardLarissa ? (
                                        <GradeLarissa imoveis={emptyStateSuggestions} site={site} codsite={codsite2} favorito={favorito} className={styles.card_lr} />
                                    ) : cardMetropole ? (
                                        <GradeMetropole imoveis={emptyStateSuggestions} site={site} codsite={codsite2} favorito={favorito} className={styles.card_mt} />
                                    ) : cardIn ? (
                                        <GradeInternacional imoveis={emptyStateSuggestions} site={site} codsite={codsite2} favorito={favorito} className={styles.card_in} />
                                    ) : cardNt ? (
                                        <GradeNorte imoveis={emptyStateSuggestions} site={site} codsite={codsite2} favorito={favorito} className={styles.card_nt} />
                                    ) : cardCp ? (
                                        <GradeCampo imoveis={emptyStateSuggestions} site={site} codsite={codsite2} favorito={favorito} className={styles.card_cp} />
                                    ) : emptyStateSuggestions.map((v: any, i: number) => (
                                        <div
                                            key={v?.id}
                                            className={site?.modelo_card > 1 ? styles.card11 : typeValidation ? styles.card1 : styles.card_company1}
                                        >
                                            {site?.modelo_card == 9 ? (
                                                <CardAtelierLista slide={v} site={site} favorito={favorito} codsite={codsite2} />
                                            ) : site?.modelo_card == 4 ? (
                                                <CardApartamentImersivo slide={v} i={i} site={site} allViewProperties={allViewProperties} favorito={favorito} codsite={codsite2} />
                                            ) : site?.modelo_card == 2 ? (
                                                <CardApartament1 slide={v} i={i} site={site} stylesCard={styles.card3} allViewProperties={allViewProperties} favorito={favorito} codsite={codsite2} />
                                            ) : site?.modelo_card == 1 ? (
                                                <CardApartament slide={v} i={i} site={site} stylesCard={styles.card2} allViewProperties={allViewProperties} favorito={favorito} codsite={codsite2} />
                                            ) : (
                                                <CardApartament3 slide={v} i={i} site={site} stylesCard={styles.card2} allViewProperties={allViewProperties} favorito={favorito} codsite={codsite2} />
                                            )}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        ) : null}
                    </div>
                ) : loading ? (
                    <div className={styles.adjust_loading}>
                        <TailSpin
                            color={horizonte ? corAcentoHz : coresAP ? coresAP.acento : coresLr ? coresLr.texto : coresMt ? coresMt.acento : coresIn ? coresIn.base : coresNt ? coresNt.base : coresCp ? coresCp.base : "rgb(195, 167, 96)"}
                            height={80}
                            width={80}
                        />
                    </div>
                ) : null}
            </div>
            {allProperties?.length > 0 ? (
                <div
                    className={
                        !typeValidation
                            ? styles.header_box_company
                            : styles.header_box
                    }
                >
                    <Stack
                        spacing={2}
                        className={isSite2507 ? styles.paginationSite2507 : undefined}
                        style={
                            isSite2507
                                ? ({
                                    ['--pagination-site-color' as any]: corLetra2,
                                    ['--pagination-site-background' as any]: corFundo,
                                    ['--pagination-site-selected-text' as any]: isColorLight(corLetra2) ? '#000000' : '#ffffff',
                                    ['--pagination-site-border' as any]: hexToRgba(corLetra2, 0.18),
                                    ['--pagination-site-hover' as any]: hexToRgba(corLetra2, 0.12),
                                    ['--pagination-site-hover-border' as any]: hexToRgba(corLetra2, 0.34)
                                } as React.CSSProperties)
                                : undefined
                        }
                    >
                        <Pagination
                            count={Math.ceil(qtd / 12)}
                            page={page}
                            sx={legado({
                                '& .MuiPaginationItem-root': {
                                fontSize: '1.3rem',  // Ajuste o tamanho da fonte conforme necessário
                                height: '40px',
                                width: '40px',
                                color: corLetra2
                            },
                            })}
                            onChange={handleChange}
                        />
                    </Stack>
                </div>
            ) : null}
        </>
    );

};

export default ListPiecesProperties;

export const getServerSideProps = async () => ({ notFound: true });
